export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    create: 'New',
    search: 'Search',
    loading: 'Loading...',
    empty: 'No data',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    back: 'Back',
    prompt_title: 'Notice',
    confirm_title: 'Confirm action',
  },
  nav: {
    dashboard: 'Dashboard',
    platform_admin: 'Platform Admin',
    campaigns: 'Campaigns',
    ad_management: 'Ad Management',
    batch_create: 'Batch Create',
    one_click_launch: 'One-Click Launch',
    one_click_records: 'Publication History',
    creatives: 'Creative Dashboard',
    creative_lifecycle: 'Creative Lifecycle',
    audience_lifecycle: 'Audience Lifecycle',
    test_planner: 'AI Test Planner',
    insights_library: 'AI Insights Library',
    experiments: 'A/B Experiments',
    ad_library: 'Ad Library',
    autopilot: 'Autopilot',
    autopilot_policies: 'Policies',
    autopilot_actions: 'Actions',
    ad_accounts: 'Ad Accounts',
    pages: 'Pages',
    pixels: 'Pixels',
    audiences: 'Audiences',
    reports: 'Ad Performance',
    pivot_report: 'Pivot Report',
    diagnostics: 'Ad Diagnostics',
    data_quality: 'Data Quality',
    automation_rules: 'Automation Rules',
    profit: 'Business Overview',
    profit_drilldown: 'Drill-down Analysis',
    report_center: 'Report Center',
    custom_report: 'Custom Dashboard',
    product_report: 'Product Report',
    store_report: 'Store Report',
    creative_board: 'Creative Dashboard',
    meta_objective_report: 'Meta Objectives',
    ai_assistant: 'AI Assistant',
    profit_breakdown: 'Breakdowns',
    commerce: 'Commerce Shops',
    platforms: 'Channels',
    notifications: 'Notifications',
    domain_monitoring: 'Domain Monitoring',
    tasks: 'Background Tasks',
    settings: 'Settings',
    logout: 'Sign out',
    profile: 'Profile',
  },
  navSection: {
    delivery: 'Delivery',
    autopilot: 'Autopilot',
    optimize: 'Optimization',
    reports: 'Reports',
    monitor: 'Monitoring & Alerts',
    intel: 'Market Intel',
    resources: 'Resources & Integrations',
  },
  commandPalette: {
    placeholder: 'Search pages or actions...',
    empty: 'No matching results',
    group_actions: 'Actions',
    action_toggle_locale: 'Switch language',
    action_logout: 'Sign out',
    action_reload: 'Reload current page',
    help_title: 'Keyboard shortcuts',
    help_palette: 'Command palette',
    help_help: 'Shortcut help',
    help_close: 'Close',
  },
  layout: {
    open_menu: 'Open menu',
    sync_in_progress: 'Syncing {count} task(s)...',
    sync_recent_failed: '{count} failed in the last hour',
    view_progress: 'View progress',
    logout_confirm: 'Sign out of your account?',
    logout_confirm_btn: 'Sign out',
    mobile_gate_title: 'Desktop browser recommended',
    mobile_gate_desc: 'The Castvo console is optimized for desktop (≥1024px wide). Some features may not display correctly on mobile.',
    mobile_gate_continue: 'Continue anyway',
    tasks_running: '{count} background task(s) running',
    tasks_failed: '{count} task(s) failed in the last hour',
  },
  tasks: {
    title: 'Background Tasks',
    subtitle: 'Async jobs dispatched by the system — structure syncs, insight reports, webhook fan-outs',
    tab_in_progress: 'In progress',
    tab_failed: 'Failed',
    tab_done: 'Completed',
    tab_all: 'All',
    col_status: 'Status',
    col_kind: 'Type',
    col_target: 'Channel / Account',
    col_progress: 'Progress / Result',
    col_time: 'Time',
    col_actions: 'Actions',
    duration: 'Took',
    retry: 'Retry',
    empty_title: 'No tasks',
    empty_in_progress_title: 'Nothing running right now',
    empty_desc: 'Trigger a sync from Channels, or wait for the next scheduled cron tick',
    retry_count: 'Retry #{count}',
    all_accounts: '(all accounts)',
    pages_target: 'Pages / Boards',
    unknown_error: 'Unknown error',
    status_queued: 'Queued',
    status_running: 'Running',
    status_ok: 'Done',
    status_partial: 'Partial',
    status_failed: 'Failed',
    kind_structure: 'Structure sync',
    kind_pages: 'Pages sync',
    kind_spend: 'Spend report',
    kind_parent_suffix: ' · parent job',
    section_automation: 'Automation runs',
    section_commerce: 'Commerce sync',
    section_test_plans: 'AI test plans',
    section_none: 'None',
    last_synced: 'Last synced {time}',
    msg_load_failed: 'Failed to load the task list',
    msg_retried: 'Re-dispatched, queued for execution',
    msg_retry_failed: 'Retry failed',
  },
  login: {
    title: 'Sign in',
    subtitle: 'Multi-channel ad management',
    email: 'Email',
    account: 'Account',
    account_placeholder: 'Username / email / phone',
    password: 'Password',
    submit: 'Sign in',
    support_hint: 'Trouble? Contact',
    totp_title: 'Two-factor verification',
    totp_subtitle: 'Enter the 6-digit code from your Authenticator app',
    totp_code_label: '6-digit code',
    recovery_code_label: 'Recovery code',
    submit_totp: 'Verify',
    use_recovery: 'Lost your device? Use a recovery code',
    use_totp: '← Use Authenticator code',
    upgrade_notice: 'Security upgrade — please sign in again (no need next time)',
    msg_need_credentials: 'Please enter your account and password',
    msg_totp_required: 'Please enter your 2FA code',
    msg_login_failed: 'Sign-in failed',
    msg_need_recovery: 'Please enter a recovery code',
    msg_need_totp: 'Please enter the 6-digit code',
    msg_verify_failed: 'Verification failed',
  },
  settings: {
    tab_profile: 'Profile',
    tab_security: 'Security',
    tab_notify: 'Notifications',
    tab_team: 'Organization Accounts',
    tab_2fa: 'Two-factor',
    tab_integrations: 'Integrations',
    tab_llm: 'AI Models',
    tab_token: 'API Token',
    danger_zone: 'Danger zone',
    delete_account: 'Delete account',
    leave_workspace: 'Leave workspace',
    page_title: 'Settings',
    page_subtitle: 'Profile, security, notification preferences and system config',
    profile: {
      card_title: 'Profile',
      label_email: 'Email',
      label_name: 'Name',
      placeholder_name: 'Your name',
      label_role: 'Role',
      save: 'Save changes',
      warn_name_required: 'Please enter a name',
      success_saved: 'Saved',
      error_save_failed: 'Save failed',
    },
    account_defaults: {
      card_title: 'Account defaults',
      label_currency: 'Default currency',
      label_timezone: 'Default timezone',
      hint_currency: 'Falls back to USD when unset.',
      hint_timezone: 'Falls back to America/New_York when unset.',
      save: 'Save defaults',
      success_saved: 'Account defaults saved',
      error_save_failed: 'Save failed',
    },
    security: {
      card_title: 'Change password',
      label_current_password: 'Current password',
      label_new_password: 'New password',
      label_confirm_password: 'Confirm new password',
      submit: 'Update password',
      warn_password_mismatch: 'New passwords do not match',
      warn_password_too_short: 'New password must be at least 8 characters',
      success_changed: 'Password updated',
      error_change_failed: 'Update failed',
    },
    notify: {
      card_title: 'Notification preferences',
      label_in_app: 'In-app notifications',
      in_app_desc: 'On (cannot be disabled; bell badge + notification center always active)',
      label_email: 'Email notifications (error-level only)',
      email_desc: 'Error-level events such as auth expiry and severe sync failures are forwarded to email. Warning-level events (e.g. domain anomalies) stay in-app only.',
      label_notify_email: 'Recipient email',
      placeholder_notify_email: 'Leave blank to use account email: {email}',
      hint_notify_email: 'Defaults to your account email. Set this if you want alerts sent to a different address (e.g. a team distribution list).',
      label_webhook: 'Webhook (Enterprise)',
      webhook_desc: 'POST alerts to a custom endpoint — coming soon',
      save: 'Save preferences',
      warn_email_invalid: 'Please enter a valid email',
      success_saved: 'Notification preferences saved',
      error_save_failed: 'Save failed',
    },
    api_token: {
      card_title: 'API Token',
      btn_refresh: 'Refresh',
      btn_create: 'New Token',
      description: 'Issue dedicated tokens for script integrations or third-party tools. The token is shown only once at creation — keep it safe.',
      col_name: 'Name',
      col_last_used: 'Last used',
      col_expires: 'Expires',
      col_created: 'Created',
      col_actions: 'Actions',
      tag_current_session: 'Current session',
      btn_revoke: 'Revoke',
      empty: 'No tokens yet. Click the button in the top right to create one.',
      never_expires: 'Never',
      never_used: 'Never used',
      load_failed: 'Failed to load tokens',
      create_dialog_title: 'New API Token',
      label_name: 'Name',
      placeholder_name: 'e.g. Data backfill script / GitHub Actions',
      label_expires: 'Validity',
      expires_30: '30 days',
      expires_90: '90 days',
      expires_365: 'One year (recommended)',
      expires_never: 'Never (not recommended)',
      submit_create: 'Create',
      warn_name_required: 'Please enter a token name',
      error_create_failed: 'Create failed',
      created_dialog_title: 'Save your token',
      created_alert_title: 'This token is shown only once',
      created_alert_desc: 'You will not be able to see it again after leaving this page. Copy it now and store it somewhere safe.',
      btn_copy: 'Copy',
      btn_close_saved: 'I saved it, close',
      copied_success: 'Copied to clipboard',
      copy_failed: 'Copy failed — please copy manually',
      revoke_current_confirm: 'Revoking 「{name}」 will end the current browser session and force a re-login. Continue?',
      revoke_confirm: 'Revoke token 「{name}」? Any published scripts using it will stop working immediately.',
      revoke_confirm_label: 'Revoke',
      revoke_success: 'Revoked',
      revoke_failed: 'Revoke failed',
    },
    danger: {
      desc_owner: 'Deleting your account also deletes the entire workspace — every team member, ad account connection, campaign and creative will be permanently erased and cannot be recovered.',
      desc_member: 'Leaving the workspace immediately revokes your access to everything here. There is no self-service recovery — an admin would need to re-invite you.',
      confirm_owner: 'This deletes your account and the entire workspace. All team members, ad account connections, campaigns and creatives will be permanently erased. This cannot be undone.',
      confirm_member: 'Leaving the workspace immediately revokes your access to every resource here. There is no self-service recovery — an admin would need to re-invite you.',
      title_owner: 'Delete account and workspace',
      title_member: 'Leave workspace',
      confirm_label: 'I understand, continue',
      prompt_title: 'Final confirmation',
      prompt_message: 'Enter your current password to confirm',
      prompt_confirm: 'Delete permanently',
      prompt_validate_too_short: 'Password must be at least 6 characters',
      success_deleted: 'Account deleted',
      error_delete_failed: 'Delete failed',
    },
  },
  rbac: {
    title: 'Team Permissions', admin_only: 'Admins only', load_failed: 'Failed to load', refresh: 'Refresh',
    new_department: 'New department',
    intro: 'Isolate data by department, assign permissions by role, scope by account',
    departments: 'Departments', members: 'Members',
    col_name: 'Name', col_type: 'Type', col_members: 'Members', col_actions: 'Actions',
    col_email: 'Email', col_role: 'Role', col_department: 'Department', col_accounts: 'Assigned accounts',
    no_department: 'No department', no_departments: 'No departments', no_members: 'No members', no_accounts: 'No accounts assigned',
    disabled: 'Disabled', delete: 'Delete', unassign: 'Un-govern', unassigned: 'Ungoverned',
    assign_accounts: 'Assign accounts ({n})', assign_accounts_title: 'Assign ad accounts',
    assign_accounts_hint: 'Check the ad accounts this member can access',
    confirm_delete_dept: 'Delete department "{name}"?', confirm_unassign: 'Remove "{name}" from governance?',
    name_required: 'Name is required', dept_name_ph: 'Department name',
    saved: 'Saved', save: 'Save', save_failed: 'Save failed', deleted: 'Deleted', delete_failed: 'Delete failed',
    create: 'Create', cancel: 'Cancel',
    roles: {
      admin: 'Admin', sub_admin: 'Sub-admin', opt_manager: 'Optimization manager', optimizer: 'Optimizer',
      design_manager: 'Design manager', designer: 'Designer', analytics_manager: 'Analytics manager', analyst: 'Analyst',
    },
    types: { optimization: 'Optimization', design: 'Design', analytics: 'Analytics' },
  },
  publicNav: {
    home: 'Home',
    help: 'Help',
    about: 'About',
    login: 'Sign in',
    console: 'Open console',
    try_free: 'Start free',
  },
  publicFooter: {
    tagline: 'Multi-channel ad management platform — connect Meta, TikTok and other major ad networks with real commerce data so every decision is grounded.',
    product: 'Product',
    company: 'Company',
    legal: 'Legal',
    features: 'Features',
    help: 'Help center',
    about: 'About us',
    business: 'Sales',
    support: 'Support',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    data_use: 'Data Use',
    data_deletion: 'Account / Data Deletion',
    sub_processors: 'Sub-processors',
    contact_us: 'Contact us',
  },
  landing: {
    nav_features: 'Features',
    nav_autopilot: 'Autopilot',
    nav_signin: 'Sign in',
    cta_start: 'Start free',
    cta_console: 'Open console',
    cta_learn: 'See features →',
    hero_badge: 'Meta · TikTok · Google · Pinterest · Microsoft',
    hero_title_l1: 'Castvo',
    hero_title_l2: 'Multi-channel ad management platform',
    hero_sub: 'Castvo is a SaaS application used to connect Facebook, Google, TikTok, Pinterest, Microsoft, and other advertising accounts through OAuth, sync ad data, manage campaigns / ad sets / ads, generate performance reports, and monitor channel authorization and ad performance.',
    hero_trust_1: 'OAuth 2.0 ad account connection',
    hero_trust_2: 'Sync and manage ad data',
    hero_trust_3: 'Reporting + authorization monitoring',

    section_features_eyebrow: 'Capabilities',
    section_features_title: 'From storefront data to automated decisions',
    section_features_sub: 'Stop optimizing for ROAS. Optimize for POAS — profit per ad dollar. Every feature is built around the same goal: turning spend into profit.',

    f_autopilot_title: 'Product-driven Autopilot',
    f_autopilot_desc: 'Spots winners and losers based on inventory, margin, and sales velocity. Drafts test ads for new SKUs, auto-pauses loss-makers, scales proven winners. Four layers of safety (approval / circuit-breaker / consistency / self-heal).',
    f_poas_title: 'Real-profit dashboard (POAS)',
    f_poas_desc: 'Joins Meta ad spend with your Shopify/WooCommerce orders to compute true profit after COGS and refunds — not the inflated ROAS Meta reports.',
    f_lifecycle_title: 'Creative lifecycle analysis',
    f_lifecycle_desc: 'Every creative is auto-tagged: rising star / scale-worthy / mediocre / fatigued / false positive. Refresh decisions backed by CTR decay, frequency, and ROAS — not gut feel.',
    f_diagnostics_title: 'Diagnostics + AI test planner',
    f_diagnostics_desc: 'Auto-detects wasted spend, audience overlap, high-frequency ads. LLM generates next week\'s A/B test plan from your historical performance — angles, copy, audiences.',
    f_adlibrary_title: 'Competitor Ad Library',
    f_adlibrary_desc: 'Search competitor ads through the Meta Ad Library API — creatives, copy, delivery period at a glance. Pin to your "inspiration library" to revisit.',
    f_commerce_title: '5 commerce integrations',
    f_commerce_desc: 'Shopify / WooCommerce / Shopline / Shoplazza / custom systems — one-click connection. Orders + products + inventory + refunds. Shopify webhook fires sub-second when stock hits zero, pausing ads instantly.',
    f_team_title: 'Team + data permissions',
    f_team_desc: 'Admins invite sub-users with role-based access (Admin / Operator / Viewer / SuperAdmin). Fine-grained — operators can pause ads but can\'t touch API keys.',
    f_audit_title: 'Complete audit + rollback',
    f_audit_desc: 'Every write — pause ad / change budget / Autopilot decision — is logged with before/after snapshots. One-click rollback on anything.',

    section_autopilot_eyebrow: 'Autopilot deep-dive',
    section_autopilot_title: 'From "watch reports + decide" to "system decides"',
    section_autopilot_sub: 'Five rules, each independently toggleable with tunable parameters. Approval mode: system finds opportunities + drafts actions, you approve. Auto mode: four layers of safety keep it from going off the rails.',
    ap_rule_1_title: 'New product test',
    ap_rule_1_desc: 'Published within N days + meets stock + margin thresholds → drafts a test ad (PAUSED state, awaiting your launch)',
    ap_rule_2_title: 'Cut losses',
    ap_rule_2_desc: 'Cumulative spend exceeds threshold but POAS below floor for N consecutive days → auto-pause',
    ap_rule_3_title: 'Inventory protect',
    ap_rule_3_desc: 'Stock drops to threshold → instantly pauses all attached ads (sub-second via Shopify webhook)',
    ap_rule_4_title: 'Scale winners',
    ap_rule_4_desc: 'POAS sustained above target for N days → auto-increase budget (+15-20% daily, with hard cap)',
    ap_rule_5_title: 'Fatigue protect',
    ap_rule_5_desc: 'Frequency > threshold OR CTR drop > threshold → auto-pause for creative refresh',

    section_channels_eyebrow: 'Supported channels',
    section_channels_title: 'Major ad networks + commerce platforms covered',

    footer_product: 'Product',
    footer_resources: 'Resources',
    footer_company: 'Company',
    footer_legal: 'Legal',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Service',
    footer_data_deletion: 'Data Deletion',
    footer_docs: 'Documentation',
    footer_changelog: 'Changelog',
    footer_status: 'Status',
    footer_contact: 'Contact',
    footer_copyright: '© 2026 Castvo. All rights reserved.',
  },
  adManagement: {
    page_title: 'Ad Management',
    page_subtitle: 'Unified cross-channel management — Campaign / Ad Set / Ad, Facebook-style table view',
    page_subtitle_mode: '{mode} workflow view · {account} / {campaign} / {adset} / {ad} hierarchy',
    ui_mode_facebook: 'Facebook',
    mode_account: 'Ad account',
    mode_accounts: 'Ad accounts',
    mode_facebook_campaign: 'Campaign',
    mode_facebook_campaigns: 'Campaigns',
    mode_facebook_adset: 'Ad Set',
    mode_facebook_adsets: 'Ad Sets',
    mode_facebook_ad: 'Ad',
    mode_facebook_ads: 'Ads',
    create_level: 'New {level}',
    view_level: 'View {level}',

    // Header actions
    refresh: 'Refresh',
    sync_ads: 'Sync ads',
    sync_ads_first_pick: 'Select an ad account first',
    sync_ads_dispatched: 'Started syncing ad structure for "{account}". The current list will refresh after it runs.',
    sync_ads_all_dispatched: 'Started syncing ad structure and the last 180 days of performance data for all authorized ad accounts ({count}).',
    sync_ads_none: 'No authorized ad accounts are available to sync.',
    sync_ads_failed: 'Failed to sync ads',
    create: 'New',
    create_campaign: 'New campaign',
    create_adset: 'New ad set (pick a campaign first)',
    create_ad: 'New ad (pick an ad set first)',

    // Filter bar
    search_placeholder: 'Search by name',
    filter_platform: 'Channel',
    filter_ad_account: 'Ad account',
    filter_status: 'Status',
    search: 'Search',
    reset: 'Reset',

    // Status options
    status_active: 'Active',
    status_paused: 'Paused',
    status_archived: 'Archived',
    status_deleted: 'Deleted',
    status_disabled: 'Disabled',
    status_suspended: 'Suspended',
    status_pending: 'Pending',
    status_pending_review: 'In review',
    status_disapproved: 'Disapproved',

    // Tabs
    tab_campaigns: 'Campaigns ({count})',
    tab_adsets: 'Ad Sets ({count})',
    tab_ads: 'Ads ({count})',

    // Breadcrumb
    clear_scope: 'Clear scope',

    // Bulk bar
    bulk_selected: '{count} selected',
    bulk_pause: 'Bulk pause',
    bulk_resume: 'Bulk resume',
    bulk_archive: 'Bulk archive',
    bulk_edit: 'Bulk edit',

    // Action labels (also used in confirm copy)
    action_pause: 'Pause',
    action_resume: 'Resume',
    action_archive: 'Archive',
    action_edit: 'Edit',
    action_edit_budget: 'Edit budget',
    inline_budget_invalid: 'Budget must be greater than 0',

    // Bulk dialog
    bulk_confirm_title: 'Bulk action',
    bulk_confirm_message: '{label} the {count} selected item(s)? This will sync to the channel.',
    bulk_success: '{label} done ({ok})',
    bulk_partial: '{label}: {ok} succeeded, {fail} failed',

    // Single-row confirms / messages
    confirm_destructive_campaign: '{label} "{name}"? This will sync to the channel and cannot be undone.',
    confirm_destructive_simple: '{label} "{name}"?',
    mutate_success: '{name} → {label}',
    mutate_failed: '{label} failed',
    load_failed: 'Load failed',

    // Hints
    hint_pick_campaign: 'Pick or open a campaign in the Campaigns tab first',
    hint_pick_adset: 'Pick or open an ad set in the Ad Sets tab first',
    ads_sort_not_supported: 'Ads tab sort is not wired to backend yet; showing by sync time desc',

    // Campaign table columns
    col_campaign_name: 'Campaign',
    col_platform: 'Channel',
    col_objective: 'Objective',
    col_status: 'Status',
    col_budget: 'Budget',
    col_spend: 'Spend',
    col_purchase_value: 'Purchase value',
    col_purchases: 'Purchases',
    col_cpa: 'CPA',
    col_impressions: 'Impressions',
    col_reach: 'Reach',
    col_frequency: 'Frequency',
    col_clicks: 'Clicks',
    col_ctr: 'CTR',
    col_cpc: 'CPC',
    col_cpm: 'CPM',
    col_conversions: 'Conversions',
    col_cost_per_conversion: 'Cost / conv.',
    col_add_to_carts: 'Adds to cart',
    col_cost_per_add_to_cart: 'Cost / ATC',
    col_checkouts: 'Initiate checkout',
    col_landing_page_views: 'Landing page views',
    col_video_views: 'Video plays',
    col_roas: 'ROAS',
    metrics_range: 'Date range',
    col_ad_account: 'Ad account',
    col_platform_campaign_id: 'Campaign ID',
    col_platform_adset_id: 'Ad set ID',
    col_platform_ad_id: 'Ad ID',
    col_buying_type: 'Buying type',
    col_start_time: 'Start time',
    col_end_time: 'End time',
    col_bid_strategy: 'Bid strategy',
    col_bid_amount: 'Bid',
    col_billing_event: 'Billing event',
    col_currency: 'Currency',
    col_balance: 'Balance',
    col_created_at: 'Created at',
    col_synced_at: 'Synced at',
    col_actions: 'Actions',
    col_parent_campaign_dynamic: '{level}',
    col_parent_adset_dynamic: '{level}',
    budget_daily_suffix: '/day',
    budget_lifetime_suffix: '/lifetime',

    // Empty states
    empty_accounts_title: 'No ad accounts',
    empty_accounts_desc: 'Authorize a channel, then sync accounts',
    empty_campaigns_title: 'No campaigns',
    empty_campaigns_desc: 'Authorize a channel, then sync',
    empty_adsets_title: 'No ad sets',
    empty_adsets_desc: 'Pick a campaign in the Campaigns tab and sync or create',
    empty_ads_title: 'No ads',
    empty_ads_desc: 'Pick an ad set in the Ad Sets tab and sync or create',

    // Ad Set table columns
    col_adset_name: 'Ad set',
    col_parent_campaign: 'Campaign',
    col_optimization_goal: 'Optimization goal',

    // Ads table columns
    col_preview: 'Preview',
    col_ad: 'Ad',
    col_parent_adset: 'Ad set',
    col_platform_creative_id: 'Creative ID',
    col_creative_name: 'Creative name',
    col_link_url: 'Destination',
    col_video_id: 'Video ID',
    col_creative_size: 'Creative specs',
    col_headline: 'Headline',
    col_primary_text: 'Primary text',
    col_description: 'Description',
    col_creative_cta: 'Type / CTA',
  },
  createDialogs: {
    campaign: {
      title: 'New Campaign',
      unsupported_capability: '{platform} does not support direct creation from Castvo yet: {missing}. Create them in {platform}, then manage status and budget here.',
      unsupported_campaign: 'Campaign',
      unsupported_adset: 'Ad Set',
      unsupported_ad: 'Ad',
      load_accounts_failed: 'Failed to load ad accounts',
      label_ad_account: 'Ad account',
      placeholder_ad_account: 'Select an ad account',
      label_name: 'Campaign name',
      placeholder_name: 'e.g. Summer Sale · Traffic',
      label_objective: 'Objective',
      objective_traffic: 'Traffic',
      objective_sales: 'Sales',
      objective_leads: 'Leads',
      objective_engagement: 'Engagement',
      objective_awareness: 'Awareness',
      objective_app_promotion: 'App promotion',
      label_status: 'Status',
      status_paused_recommended: 'Paused (recommended)',
      status_active_now: 'Launch now',
      label_budget_mode: 'Budget type',
      budget_daily: 'Daily budget',
      budget_lifetime: 'Lifetime budget',
      label_budget_amount: 'Budget amount (USD)',
      label_start_time: 'Start time',
      label_stop_time: 'End time',
      placeholder_optional: 'Optional',
      submit: 'Create',
      warn_pick_account: 'Please select an ad account',
      warn_name: 'Please enter a campaign name',
      warn_budget: 'Please enter a budget amount',
      success_created: 'Campaign created',
      error_create_failed: 'Create failed',
    },
    adset: {
      title: 'New Ad Set — {name}',
      unsupported: '{platform} does not support creating ad sets from Castvo yet. Create it in {platform} instead.',
      label_name: 'Ad set name',
      placeholder_name: 'e.g. US · 18-35 · Traffic',
      label_status: 'Status',
      status_paused: 'Paused',
      status_active_now: 'Launch now',
      label_bid_strategy: 'Bid strategy',
      bid_lowest_cost: 'Lowest cost (no cap)',
      bid_cap: 'Bid cap',
      cost_cap: 'Cost cap',
      lowest_cost_with_min_roas: 'Target cost',
      label_budget_mode: 'Budget type',
      budget_daily: 'Daily budget',
      budget_lifetime: 'Lifetime budget',
      label_budget_amount: 'Budget amount (USD)',
      label_bid_amount: 'Bid amount (USD)',
      placeholder_optional: 'Optional',
      label_optimization_goal: 'Optimization goal',
      opt_link_clicks: 'Link clicks',
      opt_impressions: 'Impressions',
      opt_reach: 'Reach',
      opt_offsite_conversions: 'Conversions',
      opt_lead_generation: 'Lead form',
      opt_post_engagement: 'Engagement',
      opt_app_installs: 'App installs',
      opt_landing_page_views: 'Landing page views',
      label_billing_event: 'Billing event',
      billing_impressions: 'Per impression (IMPRESSIONS)',
      billing_link_clicks: 'Per link click (LINK_CLICKS)',
      billing_video_views: 'Per video view (VIDEO_VIEWS)',
      divider_targeting: 'Audience targeting',
      label_saved_audience: 'Quick-fill from Saved Audience (optional)',
      placeholder_saved_audience: 'Pick a targeting template to auto-fill the fields below',
      btn_new_audience: '+ New audience',
      empty_saved_audience: 'No Saved Audiences on this account yet. Click "+ New audience" to create one inline, or fill the targeting fields manually below.',
      label_countries: 'Countries / regions (ISO codes)',
      placeholder_countries: 'Select countries',
      country_us: 'United States (US)',
      country_ca: 'Canada (CA)',
      country_gb: 'United Kingdom (GB)',
      country_de: 'Germany (DE)',
      country_fr: 'France (FR)',
      country_jp: 'Japan (JP)',
      country_au: 'Australia (AU)',
      country_sg: 'Singapore (SG)',
      country_hk: 'Hong Kong (HK)',
      country_tw: 'Taiwan (TW)',
      label_publisher_platforms: 'Placements',
      label_age_min: 'Min age',
      label_age_max: 'Max age',
      label_genders: 'Gender',
      gender_male: 'Male',
      gender_female: 'Female',
      divider_conversion: 'Conversion tracking',
      label_pixel: 'Pixel',
      placeholder_pixel: 'Select a conversion pixel',
      label_pixel_event: 'Conversion event',
      pixel_event_purchase: 'Purchase (PURCHASE)',
      pixel_event_add_to_cart: 'Add to cart (ADD_TO_CART)',
      pixel_event_initiate_checkout: 'Initiate checkout (INITIATE_CHECKOUT)',
      pixel_event_content_view: 'Landing page view (CONTENT_VIEW)',
      pixel_event_lead: 'Lead (LEAD)',
      pixel_event_complete_registration: 'Sign up (COMPLETE_REGISTRATION)',
      pixel_event_search: 'Search (SEARCH)',
      label_start_time: 'Start time',
      label_end_time: 'End time',
      submit: 'Create',
      warn_name: 'Please enter an ad set name',
      warn_budget: 'Please enter a budget amount',
      warn_countries: 'Choose at least one country',
      warn_pixel: 'This optimization goal requires a pixel',
      warn_saved_audience_missing_targeting: 'This Saved Audience has no targeting data',
      success_applied_audience: 'Applied targeting from "{name}" to the fields below',
      success_created: 'Ad set created',
      error_create_failed: 'Create failed',
    },
    ad: {
      title: 'New Ad — {name}',
      unsupported: '{platform} does not support creating ads from Castvo yet. Create it in {platform} instead.',
      label_name: 'Ad name',
      placeholder_name: 'e.g. Summer Sale · Hero v1',
      label_status: 'Status',
      status_paused: 'Paused',
      status_active_now: 'Launch now',
      label_creative_type: 'Creative type',
      creative_image: 'Image',
      creative_video: 'Video',
      label_page: 'Facebook Page',
      placeholder_page: 'Select a Page',
      fan_count_suffix: 'fans',
      label_image: 'Image creative',
      placeholder_image: 'https://... or pick from library',
      btn_library: 'Library',
      hint_image_hash_ok: '✓ image_hash bound — FB will use it directly without fetching from the web.',
      hint_image_url: 'When using a URL, FB fetches it from the web. Uploading to the library and picking an image_hash is more reliable.',
      label_video_id: 'Video ID (must already be uploaded to FB)',
      placeholder_video_id: 'e.g. 1234567890',
      label_link_url: 'Landing page URL (Link)',
      placeholder_link_url: 'https://...',
      label_display_link: 'Display link (optional)',
      placeholder_display_link: 'e.g. example.com',
      label_headline: 'Headline',
      label_primary_text: 'Primary text',
      label_description: 'Description',
      label_cta: 'Call to action (CTA)',
      cta_learn_more: 'Learn more (LEARN_MORE)',
      cta_shop_now: 'Shop now (SHOP_NOW)',
      cta_download: 'Download (DOWNLOAD)',
      cta_book_travel: 'Book now (BOOK_TRAVEL)',
      cta_sign_up: 'Sign up (SIGN_UP)',
      cta_get_offer: 'Get offer (GET_OFFER)',
      cta_apply_now: 'Apply now (APPLY_NOW)',
      cta_contact_us: 'Contact us (CONTACT_US)',
      cta_subscribe: 'Subscribe (SUBSCRIBE)',
      cta_no_button: 'No button (NO_BUTTON)',
      preview_label: 'Preview',
      preview_page_fallback: 'Page name',
      preview_sponsored: 'Sponsored · ⊕',
      preview_display_link_fallback: 'example.com',
      preview_headline_fallback: 'Headline',
      preview_cta_learn_more: 'Learn more',
      preview_cta_shop_now: 'Shop now',
      preview_cta_download: 'Download',
      preview_cta_book_travel: 'Book',
      preview_cta_sign_up: 'Sign up',
      preview_cta_get_offer: 'Get offer',
      preview_cta_apply_now: 'Apply',
      preview_cta_contact_us: 'Contact',
      preview_cta_subscribe: 'Subscribe',
      submit: 'Create',
      warn_name: 'Please enter an ad name',
      warn_page: 'Please select a Page',
      warn_link: 'Please enter a landing page URL',
      warn_image: 'Please pick a creative or enter an image URL',
      warn_video_id: 'Please enter a video_id (upload the video to FB first)',
      success_created: 'Ad created',
      error_create_failed: 'Create failed',
      error_load_creatives: 'Failed to load creatives',
      picker_title: 'Pick a creative',
      picker_empty: 'No images in the library yet — upload some in "Creatives" first.',
    },
  },
  about: {
    hero_badge: 'About us',
    hero_title: 'Make ad management painless',
    hero_sub: 'Castvo was built by engineers who spent years in media buying, growth, and product roles — we know firsthand how messy and risky multi-channel advertising gets. Our goal is simple: replace the four separate dashboards you bounce between with one clean, secure, professional console.',

    stat_channels: 'Major ad channels covered',
    stat_capabilities: 'Pro capabilities out of the box',
    stat_sync_latency: 'Data sync latency',
    stat_uptime: 'Uptime target',

    values_eyebrow: 'Our values',
    values_title: 'Four principles behind the product',
    value_focus_title: 'Focus on what matters',
    value_focus_desc: 'We are not building a "do-everything" tool. Multi-channel ad management is the one thing we obsess over — and we aim to do it better than anyone.',
    value_security_title: 'Security is non-negotiable',
    value_security_desc: 'Every access token is encrypted at rest. Compliance, privacy, and security are the first lens we apply to every product decision.',
    value_team_title: 'Built for professional teams',
    value_team_desc: 'No bloat, no gimmicks. Every detail comes from real media-buying workflows, refined over many iterations.',
    value_iteration_title: 'Ship fast, every week',
    value_iteration_desc: 'Weekly releases. Real user feedback drives the roadmap. Platform API changes get tracked the moment they ship.',

    contact_eyebrow: 'Contact us',
    contact_title: 'Need more help?',
    contact_sub: 'Whether it is a product question, a partnership, or a custom need — we would love to hear from you.',
    info_support: 'Technical support',
    info_sales: 'Sales & partnerships',
    info_hours: 'Hours',
    info_hours_value: 'Mon-Fri 09:00-18:00 (Beijing time)',
    info_coverage: 'Coverage',
    info_coverage_value: 'Serving global customers with SaaS and enterprise solutions',

    form_title: 'Tell us what you need',
    form_sub: 'We will get back to you within one business day.',
    form_name: 'Name',
    form_name_ph: 'Your name',
    form_email: 'Email',
    form_company: 'Company (optional)',
    form_company_ph: 'Company or team',
    form_message: 'Message',
    form_message_ph: 'Tell us your goals, pain points, or current ad-spend scale…',
    form_submit: 'Send inquiry',

    msg_fill_required: 'Please fill in your name, email, and message.',
    msg_mail_opened: 'Your email client is open — send the draft and we will get back to you.',
    mail_subject_prefix: 'Inquiry',
    mail_label_name: 'Name',
    mail_label_email: 'Email',
    mail_label_company: 'Company',
  },
  help: {
    hero_badge: 'Help center',
    hero_title: 'Getting started & FAQ',
    hero_sub: 'Get up and running with Castvo in 4 steps, plus answers to the questions we hear most.',
    hero_cta_console: 'Open console',
    hero_cta_start: 'Start for free',

    steps_eyebrow: 'Quick start',
    steps_title: 'First-time setup in 4 steps',
    step1_title: 'Sign up & log in',
    step1_desc: 'Create a free Castvo account with your email and sign in. No credit card required.',
    step2_title: 'Connect an ad channel',
    step2_desc: 'Go to "Channels", pick Facebook, Google, TikTok, or Pinterest, and hit "Connect". We use the platform\'s standard OAuth 2.0 flow to request read access.',
    step3_title: 'Sync your ad data',
    step3_desc: 'Once you authorize, we automatically pull ad accounts, campaigns, ad sets, and ads. Complete data appears in 1-2 minutes on the "Ad Accounts" and related pages.',
    step4_title: 'Reports & ad management',
    step4_desc: 'Use the Reports page for cross-channel performance. From Campaigns you can pause / resume / archive existing ads, or create new Campaign → Ad Set → Ad.',

    faq_eyebrow: 'FAQ',
    faq_title: 'The questions we hear most',
    faq_q1: 'How soon will I see data after connecting?',
    faq_a1: 'Usually 1-2 minutes. Large accounts (1,000+ campaigns and ads combined) may take 5-10 minutes — track progress in the Notifications center while it runs.',
    faq_q2: 'Why is the Reports page missing data for some channels?',
    faq_a2: 'Check three things: (1) the channel is authorized; (2) you have clicked "Refresh data"; (3) the account had spend during the selected date range. Facebook insight reports build asynchronously — the first pull can take 2-3 minutes.',
    faq_q3: 'When do I receive notifications?',
    faq_a3: 'Three main triggers: (1) auth tokens expired — red error; (2) sync job failed — orange warning; (3) landing-page domain not on the allowlist — orange warning. Click the bell in the header or open the Notifications center for the full list.',
    faq_q4: 'How do I enable domain monitoring?',
    faq_a4: 'Go to "Domain Monitoring" → "Add to allowlist" → enter your real domain (e.g. example.com or *.example.com) → "Scan now". The system also scans automatically every day at 02:00 and writes a notification when something looks off.',
    faq_q5: 'Will ads created in Castvo start running immediately?',
    faq_a5: 'No. Every ad is created in PAUSED state by default — a safety guardrail against accidental spend. You have to explicitly resume it (in Castvo or on the source platform) before it goes live. This is intentional.',
    faq_q6: 'What if my access token expires?',
    faq_a6: 'The account will appear as "Disconnected" on the Channels page. Click "Connect" to run the OAuth flow again. Historical data already synced is preserved.',
    faq_q7: 'Can I change the sync frequency?',
    faq_a7: 'Defaults: structure syncs every 1-2 hours; insight reports pull yesterday\'s full data every day at 02:00. Pro / Enterprise plans can bump structure syncs to every 30 or 15 minutes. You can always trigger "Refresh data" manually.',
    faq_q8: 'Why are my Pages / Pixels lists empty?',
    faq_a8: 'Pages and Pixels apply to Facebook only (Pinterest calls them Boards). You need to grant the pages_read_engagement scope (and friends) during the Facebook OAuth step — once granted, we sync them automatically.',

    support_title: 'Did not find your answer?',
    support_sub: 'Tech issues, bug reports, feature requests — we want to hear it all.',
    support_cta_contact: 'Send inquiry',
    support_email_link: 'Email support@castvo.app →',
  },
  notFound: {
    title: 'Page not found',
    desc_l1: 'The page you are looking for may have moved, been removed, or never existed.',
    desc_l2: 'Double-check the link, or head back to the homepage.',
    cta_console: 'Back to console',
    cta_home: 'Back to home',
    cta_back: 'Go back',
    hint_prefix: 'Think this is a bug? Email',
  },
  onboarding: {
    title: 'Get started',
    subtitle: 'Complete these steps to start tracking real profit',
    progress: '{done}/{total} completed',
    dismiss: 'Dismiss',
    done: 'Done',
    step_connect_platform_title: 'Connect an ad platform',
    step_connect_platform_desc: 'Authorize Facebook and other channels to import ad data',
    step_connect_platform_cta: 'Connect',
    step_connect_store_title: 'Connect a store',
    step_connect_store_desc: 'Connect Shopify and others to sync real orders and revenue',
    step_connect_store_cta: 'Connect',
    step_set_product_cost_title: 'Sync products & set cost',
    step_set_product_cost_desc: 'Set product cost (COGS) to compute real profit',
    step_set_product_cost_cta: 'Set up',
    step_create_ad_title: 'Create your first ad',
    step_create_ad_desc: 'Quickly build campaigns with cross-multiply batch create',
    step_create_ad_cta: 'Create',
    step_setup_automation_title: 'Set up a rule or Autopilot',
    step_setup_automation_desc: 'Let the system auto-monitor, adjust budgets, or pause underperformers',
    step_setup_automation_cta: 'Set up',
    step_view_profit_title: 'View the profit dashboard',
    step_view_profit_desc: 'See ad spend, revenue, and net profit in one place',
    step_view_profit_cta: 'View',
  },
  dashboard: {
    page_title: '{greeting}, {name}',
    page_subtitle: 'Last 7 days · channel status · latest alerts',
    btn_refresh: 'Refresh',
    btn_sync_all: 'Sync all',

    greeting_late_night: 'Hi',
    greeting_morning: 'Good morning',
    greeting_noon: 'Hello',
    greeting_afternoon: 'Good afternoon',
    greeting_evening: 'Good evening',

    onboard_title: 'Welcome to Castvo',
    onboard_sub: 'Three steps to start managing your multi-channel ads in one place',
    onboard_step1_title: 'Connect an ad channel',
    onboard_step1_desc: 'Authorize Facebook, Google, TikTok, or Pinterest',
    onboard_step1_cta: 'Connect',
    onboard_step2_title: 'Sync ad accounts',
    onboard_step2_desc: 'Pull ad accounts and historical data from the channels you connected',
    onboard_step2_cta: 'Sync now',
    onboard_step3_title: 'Create your first campaign',
    onboard_step3_desc: 'Or keep managing the campaigns you already synced',
    onboard_step3_cta: 'New campaign',

    kpi_spend: 'Spend (7d)',
    kpi_impressions: 'Impressions',
    kpi_clicks: 'Clicks',
    kpi_ctr: 'CTR',
    kpi_conversions: 'Conversions',
    kpi_roas: 'ROAS',

    card_trend_title: 'Spend trend (last 7 days)',
    card_platform_title: 'Channel breakdown (last 7 days)',
    link_full_report: 'Full report →',
    link_view_report: 'View report →',
    link_manage: 'Manage →',
    link_all: 'View all →',

    col_channel: 'Channel',
    col_spend: 'Spend',
    col_impressions: 'Impressions',
    col_clicks: 'Clicks',
    col_conversions: 'Conversions',
    col_roas: 'ROAS',

    empty_table_prefix: 'No data yet. Connect an ad platform on',
    empty_table_link_platforms: 'Channels',
    empty_table_middle: 'then head to',
    empty_table_link_reports: 'Reports',
    empty_table_suffix: 'and click "Refresh data".',

    card_status_title: 'Channel status ({connected}/{total})',
    status_connected: 'Connected · {count}',
    status_disconnected: 'Disconnected',

    card_notifications_title: 'Recent notifications',
    empty_notifications: 'No notifications',

    card_team_title: 'Team activity',
    empty_team: 'No activity yet',
    actor_deleted: '(deleted user)',

    card_quick_title: 'Quick actions',
    quick_new_campaign: 'New campaign',
    quick_view_reports: 'Cross-channel reports',
    quick_domain_monitor: 'Domain monitoring',
    quick_platforms: 'Channel authorizations',

    time_just_now: 'just now',
    time_minutes_ago: '{n} min ago',
    time_hours_ago: '{n} h ago',

    msg_load_failed: 'Load failed',
    msg_sync_failed: 'Sync failed',
    msg_sync_dispatched: 'Dispatched {count} sync job(s) — refresh in a moment to see the latest data',
  },
  commerce: {
    title: 'Stores',
    subtitle:
      'Connect Shopify / WooCommerce / Shopline / Shoplazza / custom systems and feed real orders / refunds / margin into ad ROAS — to compute true POAS',
    refresh: 'Refresh',
    connect: 'Connect store',
    col_shop: 'Store',
    col_currency: 'Currency',
    col_cogs_rate: 'COGS rate',
    col_per_order_cost: 'Per-order cost',
    col_last_sync: 'Last sync',
    col_actions: 'Actions',
    needs_reauth_tag: 'Re-auth needed',
    action_sync: 'Sync orders',
    action_sync_products: 'Sync products',
    product_sync_progress: 'Syncing · {count} products',
    msg_products_synced: 'Synced {count} products. They are now available in One-click launch.',
    msg_product_sync_failed: 'Product sync failed. Please try again.',
    action_cost_settings: 'Cost settings',
    action_register_webhook: 'Register webhook',
    register_webhook_tip: 'Register real-time events — out-of-stock etc. fire instantly',
    action_reauth: 'Re-authorize',
    reauth_tip: 'Re-run Shopify OAuth to get a fresh refreshable token',
    action_disconnect: 'Disconnect',
    empty_title: 'No stores connected yet',
    empty_desc:
      'Once connected, the system pulls your orders + refunds + discounts to translate channel ROAS into true POAS',
    sync_not_yet: 'Not synced yet',
    sync_just_now: 'Just now',
    sync_minutes_ago: '{n} min ago',
    sync_hours_ago: '{n} h ago',
    sync_days_ago: '{n} d ago',
    connect_dialog_title: 'Connect a store',
    field_provider: 'Platform',
    provider_shopify: 'Shopify',
    provider_shopline: 'Shopline',
    provider_shoplazza: 'Shoplazza',
    provider_woocommerce: 'WooCommerce',
    provider_custom: 'Custom system / API',
    field_shop_domain: 'Store domain',
    shopify_hint:
      'Only the *.myshopify.com part — custom domains will not work. Next step redirects to the Shopify authorization page.',
    shopline_hint_pre:
      'Enter the Shopline admin domain, only the *.myshopline.com part. Next step redirects to Shopline authorization. First create an app in Shopline Developer and configure the callback',
    shoplazza_hint_pre:
      'Enter the Shoplazza store domain, *.myshoplaza.com (note the single z). First create an app in Shoplazza Developer and configure the callback',
    field_store_url: 'Store URL (HTTPS)',
    woo_url_hint: 'No trailing / or path, just the root domain',
    woo_oauth_btn: 'One-click authorize & connect',
    woo_oauth_hint:
      'Enter your WooCommerce site URL (e.g. https://shop.example.com). After clicking authorize, just hit "Approve" in your admin — no need to copy keys manually. Requires WooCommerce ≥ 8.5 and a publicly accessible site.',
    woo_manual_toggle: 'Advanced: enter API keys manually',
    field_consumer_key: 'Consumer Key',
    field_consumer_secret: 'Consumer Secret',
    woo_secret_hint:
      'In the Woo admin: Settings → Advanced → REST API → Add key, Read permission is enough.',
    cancel: 'Cancel',
    submit_connect: 'Authorize & connect',
    settings_dialog_title: 'Cost settings · {name}',
    field_shop_display_name: 'Display name',
    field_cost_mode: 'Cost method',
    cost_mode_ratio: 'Flat cost ratio',
    cost_mode_per_product: 'Per-product real cost',
    cost_mode_hint:
      'Flat ratio: estimate cost of goods as a fixed percentage of revenue — simple but approximate. Per-product: use each product\'s real purchase cost — more accurate (recommended when you have product cost data).',
    field_default_cogs: 'Default COGS rate',
    cogs_hint_ratio:
      'Estimate cost of goods as a percentage of net revenue. E.g. apparel often 35-45%, electronics 60-70%.',
    cogs_hint_per_product:
      'Fallback ratio: only applies to products without a real purchase cost; products with a cost use the real value.',
    field_product_cost: 'Product costs',
    manage_product_cost: 'Manage product costs',
    product_cost_hint: 'Enter the real purchase cost (USD) per product; one-click prefill from Shopify.',
    field_per_order_cost: 'Per-order fixed cost ($)',
    per_order_cost_hint: 'Shipping cost + payment fees + packaging and other per-order fixed costs',
    save_recalc: 'Save (recalculate last 90 days)',
    msg_reauth_redirect: 'Redirecting to Shopify for re-authorization…',
    msg_reauth_failed: 'Failed to start re-authorization',
    msg_load_failed: 'Load failed',
    msg_shopify_domain_required: 'Enter the store domain, e.g. snail-shop.myshopify.com',
    msg_shopify_redirect: 'Redirecting to Shopify authorization…',
    msg_shopline_domain_required: 'Enter the store domain, e.g. myshop.myshopline.com',
    msg_shopline_redirect: 'Redirecting to Shopline authorization…',
    msg_shoplazza_domain_required: 'Enter the store domain, e.g. myshop.myshoplaza.com',
    msg_shoplazza_redirect: 'Redirecting to Shoplazza authorization…',
    msg_woo_store_required: 'Enter the store URL, e.g. https://shop.example.com',
    msg_woo_redirect: 'Redirecting to WooCommerce authorization…',
    msg_woo_fields_required: 'Please fill in the store URL + Consumer Key + Consumer Secret',
    msg_connected: 'Connected {name}',
    msg_connect_failed: 'Connection failed',
    msg_settings_saved: 'Saved, recalculating the last 90 days of profit...',
    msg_save_failed: 'Save failed',
    msg_webhook_ok: 'Webhook registered — out-of-stock instantly pauses ads',
    msg_webhook_partial: 'Partly failed: {failed}',
    msg_webhook_failed: 'Registration failed',
    msg_sync_failed: 'Sync failed: {error}',
    msg_sync_done: 'Sync complete · pulled {orders} orders, refreshed {dates} days of KPIs',
    msg_sync_failed_short: 'Sync failed',
    confirm_disconnect:
      'Disconnect "{name}"? The store\'s historical order data will be deleted too and cannot be recovered.',
    confirm_disconnect_title: 'Disconnect store',
    confirm_disconnect_label: 'Disconnect',
    msg_disconnected: 'Disconnected',
    msg_action_failed: 'Action failed',
    msg_connected_query: 'Connected {provider} {shop}',
    msg_shopify_auto_connected:
      'If you did not see an authorization page, this store had already authorized our app — the connection completed automatically',
    msg_shop_already_connected: 'Store {shop} is already connected',
    msg_shopify_auth_failed: 'Failed to start Shopify authorization',
    custom_blurb:
      'For self-built storefronts / other commerce systems. After creating it you get an ingest key — have your system POST orders to our endpoint to unlock POAS / true profit attribution.',
    custom_field_name: 'Name',
    custom_field_currency: 'Currency',
    custom_field_cost_mode: 'Cost mode',
    custom_field_default_cogs: 'Default COGS rate',
    custom_default_cogs_hint: '0 – 1, e.g. 0.4 means 40%',
    custom_field_per_order_cost: 'Per-order fixed cost',
    custom_key_title: 'Ingest key (shown only once)',
    custom_key_warning:
      'Copy and save it now. This key is shown only once and cannot be viewed again after closing; if lost, use "Rotate key".',
    custom_key_howto: 'POST orders to {endpoint} with header Authorization: Bearer <key>.',
    custom_key_copied: 'I have copied it',
    action_rotate_key: 'Rotate key',
    rotate_tip: 'Generate a new ingest key; the old key is revoked immediately',
    confirm_rotate:
      'Rotate the ingest key for "{name}"? The old key is revoked immediately and you must update your system config.',
    confirm_rotate_title: 'Rotate ingest key',
    confirm_rotate_label: 'Rotate',
    msg_custom_name_required: 'Please enter a name',
  },
  platforms: {
    title: 'Channel authorization',
    subtitle: 'Manage OAuth authorization for each ad platform; one channel can hold multiple accounts',
    refresh: 'Refresh',
    connected: 'Connected',
    disconnected: 'Not connected',
    connect: 'Connect',
    add_account: 'Add account',
    unnamed: 'Unnamed',
    sync: 'Sync',
    syncing: 'Syncing',
    history: 'History',
    disconnect: 'Disconnect',
    badge_beta: 'Beta',
    badge_beta_tip: 'Read data + pause available; some editing features in progress',
    badge_connect_only: 'Connect only',
    badge_connect_only_tip: 'Only authorization is supported for now; data sync in progress',
    msg_load_failed: 'Failed to load channel list',
    msg_auth_failed: 'Failed to start authorization',
    confirm_disconnect: 'Revoke authorization for {name}? The local token will be revoked.',
    confirm_disconnect_fallback: 'this account',
    confirm_disconnect_title: 'Revoke authorization',
    confirm_disconnect_label: 'Revoke',
    msg_disconnected: 'Authorization revoked',
    msg_disconnect_failed: 'Failed to revoke authorization',
    msg_sync_dispatched:
      'Dispatched {count} sync job(s) — FB usually takes 1–2 min; you can watch progress on this page',
    msg_sync_dispatch_failed: 'Failed to dispatch sync',
    msg_connected: 'Connected {code}',
    sync_just_now: 'Just now',
    sync_seconds_ago: '{n}s ago',
    sync_minutes_ago: '{n} min ago',
    sync_hours_ago: '{n} h ago',
    sync_in_progress: 'Syncing · {done}/{total} accounts',
    sync_queued: 'Queued · {time}',
    sync_running: 'Syncing... · started {time}',
    sync_ok: 'Last sync succeeded · {time}',
    sync_counts: 'Accounts {accounts} · Pages {pages} · Campaigns {campaigns} · Ads {ads}',
    sync_sub_failed: '{n} account(s) failed',
    sync_partial: 'Partly succeeded · {time}',
    sync_failed: 'Sync failed · {time}',
    history_title: 'Sync history',
    history_title_named: 'Sync history · {name}',
    filter_all_kinds: 'All types',
    filter_all_status: 'All statuses',
    kind_structure: 'Structure sync',
    kind_pages: 'Pages sync',
    kind_insights: 'Insights',
    status_queued: 'Queued',
    status_running: 'Running',
    status_ok: 'Succeeded',
    status_partial: 'Partial',
    status_failed: 'Failed',
    history_empty: 'No matching records (kept for 30 days)',
    col_time: 'Time',
    col_kind: 'Type',
    col_account: 'Account',
    col_status: 'Status',
    col_duration: 'Duration',
    col_result: 'Result',
    col_actions: 'Actions',
    main_task: '— (main task)',
    retry: 'Retry',
    retried_n: 'Retried {n}x',
    msg_history_load_failed: 'Failed to load history',
    msg_retry_dispatched: 'Re-dispatched',
    msg_retry_failed: 'Retry failed',
    cnt_accounts: 'Accounts',
    cnt_bm: 'BM',
    cnt_campaigns: 'Campaigns',
    cnt_ad_sets: 'Ad sets',
    cnt_ads: 'Ads',
    cnt_pages: 'Pages',
    cnt_rows: 'Rows',
  },
  adAccounts: {
    title: 'Ad accounts',
    subtitle: 'Ad accounts across all channels — view balance / status and manage sync settings',
    refresh: 'Refresh',
    search_placeholder: 'Search account name',
    filter_platform: 'Channel',
    filter_status: 'Status',
    search: 'Search',
    reset: 'Reset',
    status_active: 'Active',
    status_disabled: 'Disabled',
    status_suspended: 'Suspended',
    status_pending: 'Pending',
    col_account: 'Account',
    col_channel: 'Channel',
    col_bm: 'BM',
    col_status: 'Status',
    col_currency: 'Currency',
    col_balance: 'Balance',
    col_spend_cap: 'Spend cap',
    col_spend_7d: 'Spend (7d)',
    col_impressions: 'Impr.',
    col_clicks: 'Clicks',
    col_roas: 'ROAS',
    col_last_sync: 'Last sync',
    col_actions: 'Actions',
    sync: 'Sync',
    empty_title: 'No ad accounts yet',
    empty_desc: 'Authorize an ad platform on the Channels page and accounts will sync in automatically',
    empty_filtered_title: 'No matching accounts',
    empty_filtered_desc: 'Try adjusting the filters or clearing the search',
    msg_load_failed: 'Load failed',
    msg_sync_dispatched: 'Sync job dispatched',
    msg_sync_failed: 'Sync failed',
  },
  audiences: {
    title: 'Audiences',
    subtitle:
      'Custom audiences, lookalikes, saved audiences — viewed across platforms in one place, syncable from channels',
    refresh: 'Refresh',
    create: 'New audience',
    menu_saved: 'Saved Audience',
    menu_saved_desc: 'Targeting template (who to reach)',
    menu_website: 'Website audience',
    menu_website_desc: 'Pixel-based site visitors',
    menu_customer_list: 'Customer List',
    menu_customer_list_desc: 'Upload customer emails/phones (hashed locally)',
    menu_lookalike: 'Lookalike',
    menu_lookalike_desc: 'Expand a similar audience from an existing one',
    search_placeholder: 'Search audience name',
    filter_platform: 'Channel',
    filter_ad_account: 'Ad account',
    filter_type: 'Type',
    search: 'Search',
    reset: 'Reset',
    sync_from_account: 'Sync from account...',
    sync_audiences: 'Sync audiences',
    type_custom: 'Custom audience',
    type_lookalike: 'Lookalike',
    type_saved: 'Saved audience',
    type_special: 'Special audience',
    col_audience: 'Audience',
    col_type: 'Type',
    col_size: 'Size',
    col_description: 'Description',
    col_created: 'Created',
    col_last_sync: 'Last sync',
    empty_title: 'No audiences yet',
    empty_desc:
      'Pick an ad account and click "Sync audiences" at the top right to pull this account\'s custom/lookalike audiences',
    empty_action: 'New audience',
    empty_filtered_title: 'No matching audiences',
    empty_filtered_desc: 'Try adjusting the filters',
    msg_load_failed: 'Load failed',
    msg_select_account: 'Please select an ad account to sync',
    msg_synced: 'Synced {count} audience(s)',
    msg_sync_failed: 'Sync failed',
  },
  notifications: {
    title: 'Notifications',
    subtitle: 'Alerts for expired auth, sync failures, domain issues, plus system messages',
    refresh: 'Refresh',
    mark_all_read: 'Mark all read',
    tab_all: 'All',
    tab_auth_expired: 'Auth expired',
    tab_sync_failed: 'Sync error',
    tab_domain_alert: 'Domain alert',
    tab_policy_event: 'Policy event',
    tab_system: 'System',
    filter_all_levels: 'All levels',
    level_info: 'Info',
    level_warning: 'Warning',
    level_error: 'Error',
    unread_only: 'Unread only',
    resolve: 'Resolve',
    delete: 'Delete',
    empty_filtered_title: 'No notifications in this category',
    empty_title: 'No notifications',
    empty_desc: 'Expired auth, heartbeat issues and domain monitoring alerts all show up here',
    msg_load_failed: 'Load failed',
    msg_mark_failed: 'Failed to mark',
    msg_all_read: 'All marked as read',
    msg_action_failed: 'Action failed',
    confirm_delete: 'Delete this notification?',
    confirm_delete_label: 'Delete',
    msg_delete_failed: 'Delete failed',
  },
  productCost: {
    title: 'Product costs · {name}',
    search_placeholder: 'Search by product title',
    search: 'Search',
    refresh: 'Refresh',
    sync_from_shopify: 'Pull costs from Shopify',
    col_title: 'Product title',
    col_price: 'Current price',
    col_unit_cost: 'Purchase cost (USD)',
    unit_cost_placeholder: 'Unset',
    empty_title: 'No products synced yet',
    empty_desc:
      'This store has no synced products yet — sync on the Stores page first, or click "Pull costs from Shopify"',
    done: 'Done',
    msg_load_failed: 'Load failed',
    msg_saved: 'Saved',
    msg_save_failed: 'Save failed',
    msg_costs_synced: 'Pulled {updated} product cost(s) from Shopify',
    msg_sync_failed: 'Failed to pull costs',
  },
  creatives: {
    title: 'Creative Dashboard',
    subtitle: 'Manage creative assets, performance rankings and tag analysis in one place',
    report_title: 'Creative Dashboard',
    report_subtitle: 'Creative assets, top creatives and tag analysis are unified here',
    mode_gallery: 'Gallery',
    mode_analytics: 'Performance',
    open_reports: 'View creative reports',
    back_to_library: 'Back to library',
    refresh: 'Refresh',
    upload: 'Upload creative',
    search_placeholder: 'Search creative name',
    ad_account_placeholder: 'Ad account',
    type_placeholder: 'Type',
    type_image: 'Image',
    type_video: 'Video',
    type_carousel: 'Carousel',
    type_collection: 'Collection',
    type_text: 'Copy',
    search: 'Search',
    reset: 'Reset',
    window_label: 'Time window',
    window_3d: 'Last 3 days',
    window_7d: 'Last 7 days',
    stage_label: 'Stage',
    sort_label: 'Sort',
    sort_default: 'Default',
    sort_roas: 'ROAS',
    sort_spend: 'Spend',
    sort_ctr: 'CTR',
    sort_conversions: 'Conversions',
    sort_desc: 'Descending',
    sort_asc: 'Ascending',
    stage_all: 'All',
    stage_rising_star: '🌟 Rising star',
    stage_scale_worthy: '🚀 Scale-worthy',
    stage_just_launched: '🆕 Just launched',
    stage_mediocre: '🟡 Mediocre',
    stage_fatigued: '🔥 Fatigued',
    stage_false_positive: '⚪ False positive',
    gallery_empty_title: 'Your creative library is empty',
    gallery_empty_desc: 'Click upload to add images/videos, or sync existing creatives from connected channels',
    gallery_nomatch_title: 'No matching creatives',
    gallery_nomatch_desc: 'Try adjusting your filters',
    fb_ready: 'FB ready',
    fb_ready_tip: 'Registered with FB — uses image_hash when creating ads',
    delete: 'Delete',
    analytics_empty_title: 'No creative performance data yet',
    analytics_empty_desc: 'Switch the time window or stage filter, or check whether ads are live',
    col_thumbnail: 'Thumbnail',
    col_name: 'Name',
    col_type: 'Type',
    col_stage: 'Stage',
    col_spend: 'Spend',
    col_roas: 'ROAS',
    col_ctr: 'CTR',
    col_conversions: 'Conv.',
    col_ad_count: 'Ads',
    col_launched: 'Launched',
    col_actions: 'Actions',
    no_data: 'No data',
    ad_count_tip: 'Used in {count} ad(s)',
    detail: 'Details',
    drawer_title_default: 'Creative details',
    perf_summary: 'Performance summary',
    no_perf_data_desc: 'This creative is not yet linked to delivery data',
    stat_spend: 'Spend',
    stat_roas: 'ROAS',
    stat_ctr: 'CTR',
    stat_conversions: 'Conv.',
    m_impressions: 'Impressions',
    m_clicks: 'Clicks',
    m_purchases: 'Purchases',
    m_purchase_value: 'Purchase value',
    m_reach: 'Reach',
    m_frequency: 'Frequency',
    m_cpa: 'CPA',
    m_launched: 'Launched',
    ads_using: 'Ads using this creative ({count})',
    no_related_ads: 'No linked ads yet',
    ad_link: 'Ad #{id}',
    upload_title: 'Upload creative',
    upload_ad_account: 'Ad account',
    upload_ad_account_placeholder: 'Select account',
    upload_file: 'File',
    upload_hint: 'Images ≤ 10MB (jpg/png/gif/webp); videos ≤ 200MB (mp4/mov/webm)',
    upload_preview: 'Preview',
    upload_name: 'Name (optional)',
    upload_name_placeholder: 'Leave blank to use the file name',
    cancel: 'Cancel',
    upload_btn: 'Upload',
    relative_minutes: '{count} min ago',
    relative_hours: '{count} h ago',
    relative_days: '{count} d ago',
    relative_months: '{count} mo ago',
    relative_years: '{count} y ago',
    msg_load_failed: 'Load failed',
    msg_pick_file: 'Please choose a file',
    msg_pick_account: 'Please select an ad account',
    msg_uploaded: 'Uploaded',
    msg_upload_failed: 'Upload failed',
    confirm_delete: 'Delete creative "{name}"?',
    confirm_delete_label: 'Delete',
    msg_deleted: 'Deleted',
    msg_delete_failed: 'Delete failed',
  },
  creativeLifecycle: {
    preview_title: "Preview material",
    preview_version: "Select creative record",
    preview_version_label: "Creative {index} · ID {id}",
    preview_unavailable: "Preview unavailable. The media may be missing, expired, or inaccessible.",
    preview_retry: "Reload",
    preview_poster_only: "Only a video poster is available; no playable video was returned.",
    preview_material_only: "This shows the source material. Ad copy, buttons and placement appearance may differ on the platform.",
    preview_close: "Close",

    title: 'Creative fatigue alerts / Lifecycle management',
    subtitle: 'Aggregates all attached ads per creative and auto-classifies stage — rising star / scale-worthy / fatigued / false positive — so refresh decisions are data-driven',
    refresh: 'Refresh',
    stage_all: 'All',
    stage_just_launched: 'New',
    stage_rising_star: 'Rising star',
    stage_scale_worthy: 'Scale-worthy',
    stage_mediocre: 'Mediocre',
    stage_fatigued: 'Fatigued',
    stage_false_positive: 'False positive',
    callout_good_label: 'This week\'s "scale-worthy" creative spend',
    callout_good_hint: 'These are your current winners — copy / increase budget first',
    callout_bad_label: 'This week\'s "fatigued + false positive" creative spend',
    callout_bad_hint: 'Consider pausing and refreshing, or tag "don\'t reuse this angle next time"',
    col_creative: 'Creative',
    on_n_ads: 'on {count} ad(s)',
    tag_btn: 'Tag',
    col_stage: 'Stage',
    age_days: '{count} d',
    col_reason: 'Reasoning',
    col_ctr_7d: 'CTR (7d)',
    col_frequency_7d: 'Freq. (7d)',
    col_cpa_7d: 'CPA (7d)',
    col_roas_7d: 'ROAS (7d)',
    col_spend_7d: 'Spend (7d)',
    col_traffic_7d: 'Traffic (7d)',
    col_conversion_7d: 'Conversion (7d)',
    col_efficiency_7d: 'Efficiency (7d)',
    col_spend_window: 'Spend / Reach',
    metric_impressions: 'Impr.',
    metric_clicks: 'Clicks',
    metric_purchases: 'Purchases',
    metric_conversions: 'Conv.',
    metric_revenue: 'Revenue',
    metric_frequency: 'Freq.',
    metric_spend_7d: '7d',
    metric_spend_3d: '3d',
    metric_reach: 'Reach',
    launched_at: 'Launched {date}',
    material_group_counts: 'Same material: {creatives} creatives · {ads} ads · {adsets} ad sets · {campaigns} campaigns · {accounts} accounts',
    material_source_label: 'Matched by',
    material_source_content_sha256: 'File content',
    material_source_fb_image_hash: 'FB image hash',
    material_source_video_id: 'Video ID',
    material_source_source_url: 'Source URL',
    material_source_file_url: 'File URL',
    material_source_thumbnail_url_fallback: 'Thumbnail fallback',
    material_source_platform_creative_id: 'Platform creative ID',
    material_source_creative_id_fallback: 'Local creative ID fallback',
    material_source_unknown: 'Unknown',
    col_actions: 'Actions',
    view_ads: 'View ads',
    empty_title: 'No creatives in this category',
    empty_desc: 'New creatives are only classified 3 days after launch. You can tag them meanwhile for easier tracing.',
    tag_type_hook: 'Hook',
    tag_type_angle: 'Angle',
    tag_type_format: 'Format',
    tag_type_selling_point: 'Selling point',
    tag_type_custom: 'Custom',
    stage_hint_just_launched: 'Just launched, not enough data',
    stage_hint_rising_star: 'Early but already above baseline — consider bumping budget to test',
    stage_hint_scale_worthy: 'Consistently strong — your main scaling driver',
    stage_hint_mediocre: 'Average — keep watching or split-test',
    stage_hint_fatigued: 'Metrics declining — refresh the creative',
    stage_hint_false_positive: 'Strong day one then crashed — don\'t reuse this angle next time',
    dialog_title: 'Add tag to "{name}"',
    dialog_tag_type: 'Tag type',
    dialog_tag_value: 'Tag value',
    dialog_tag_value_placeholder: 'e.g. pain point / price advantage / UGC / comparison',
    dialog_current: 'Existing tags',
    dialog_close: 'Close',
    dialog_add: 'Add',
    msg_load_failed: 'Load failed',
    msg_input_tag: 'Please enter the tag content',
    msg_added: 'Added',
    msg_add_failed: 'Add failed',
    msg_delete_failed: 'Delete failed',
  },
  adLibrary: {
    title: 'Ad Library · Competitor monitoring',
    subtitle: "Search competitors' live ads via Meta Ad Library — creatives, copy, and delivery period at a glance. Other channels coming soon.",
    notice_title: 'About Meta Ad Library data coverage',
    notice_intro: "Meta's public ad library has limited coverage — not finding ads usually means the data simply isn't in scope, not a system failure:",
    notice_li_eu: 'EU member states + UK (DE / FR / IT / ES / NL / SE / GB, etc.): under the DSA, all ad types are public — commercial, brand, and political alike.',
    notice_li_us: 'US / rest of the world: Meta only exposes "political and issue ads". Searching commercial brands like nike / adidas with US usually returns 0 results — switch "Ad type" to "Political/issue" to see US data.',
    notice_li_pageid: "Page ID is more precise than keywords: find the competitor page's numeric id on facebook.com and paste it here to avoid fuzzy brand-term matching.",
    notice_li_empty: 'Empty results ≠ a system error; any actual error shows a message immediately.',
    tab_search: 'Search',
    tab_favorites: 'Inspiration ({count})',
    search_type_fuzzy: 'Fuzzy',
    search_type_exact: 'Exact',
    apify_loading_hint: 'Auto-scrape is slow — fetching live ads, please wait (about 10–60s)…',
    view_on_meta: 'View on Meta ↗',
    country_label: 'Country (required)',
    country_placeholder: 'Select delivery countries',
    terms_label: 'Keywords (copy / brand)',
    terms_placeholder: 'e.g. nike running, shipping, skincare serum',
    page_id_label: 'Page ID (optional, comma-separated — more precise than keywords)',
    page_id_placeholder: 'e.g. 15087023444,42155876830',
    status_label: 'Status',
    status_active: 'Active',
    status_inactive: 'Inactive',
    status_all: 'All',
    ad_type_label: 'Ad type',
    ad_type_all: 'All (visible in EU+UK)',
    ad_type_political: 'Political/issue (visible worldwide)',
    media_label: 'Media type',
    media_all: 'All',
    media_image: 'Image',
    media_video: 'Video',
    media_meme: 'Meme',
    platform_label: 'Platform',
    platform_placeholder: 'Any',
    date_min_label: 'Delivery start (earliest)',
    date_max_label: 'Delivery start (latest)',
    date_placeholder: 'Optional',
    search_btn: 'Search',
    empty_start_title: 'Start searching',
    empty_start_desc: 'Pick countries (DE/GB recommended first) + keywords or Page ID, then search.',
    empty_nores_title: 'No ads returned for these filters',
    empty_nores_desc: 'Common causes: 1) The country is outside DSA coverage (US/Asia etc. only allow political ads); 2) Keywords are too specific — try a brand term or a Page ID; 3) No matching active ads — switch status to "Inactive" or "All".',
    unknown_advertiser: 'Unknown advertiser',
    delivering: 'Active',
    delivered_for: 'Running {duration}',
    favorited: 'Favorited',
    favorite_to: 'Save to inspiration',
    no_preview: 'No creative preview',
    chip_spend: 'Spend {range} {currency}',
    chip_impressions: 'Impressions {range}',
    fb_original: 'FB original ↗',
    load_more: 'Load next page',
    fav_empty_title: 'Inspiration library is empty',
    fav_empty_desc: 'Find competitor ads you like in the "Search" tab and star them to save here',
    favorited_at: 'Saved on {date}',
    remove: 'Remove',
    days: '{count} d',
    msg_pick_country: 'Please select at least one country',
    msg_input_terms: 'Enter a keyword to search (or a competitor Page ID to see all their ads)',
    msg_search_failed: 'Search failed',
    msg_load_fav_failed: 'Failed to load favorites',
    msg_favorited: 'Saved to inspiration',
    msg_favorite_failed: 'Failed to save',
    confirm_remove: 'Remove "{name}" from inspiration?',
    confirm_remove_label: 'Remove',
    msg_remove_failed: 'Remove failed',
    pick_from_products: 'Pick from products',
    picker_title: 'Pick keywords from your products',
    picker_search_placeholder: 'Search product titles…',
    picker_empty_title: 'No synced products yet',
    picker_empty_desc: 'Connect a store under "Commerce channels" and sync products first — they will then appear here as keyword sources.',
    picker_untitled: 'Untitled product',
    picker_use_keyword: 'Use as keyword',
    picker_ai_expand: 'AI-expand to competitor keywords',
    picker_expanded_hint: 'Click a keyword to fill the search box:',
    picker_expand_cost: 'This AI expansion cost ≈ ${cost}',
    msg_load_products_failed: 'Failed to load products',
    msg_pick_product: 'Please select at least one product first',
    msg_expand_failed: 'AI expansion failed',
  },
  automationRules: {
    form_channel: 'Delivery channel',
    channel_default: 'In-app + email only (default)',
    channel_hint: 'In addition to in-app and email, also push match notifications to the selected IM channel.',
    title: 'Automation rules',
    subtitle: 'Multi-condition triggers + one-click execute / notify / adjust budget — automate away the waste found in ad checkups',
    refresh: 'Refresh',
    create: 'New rule',
    col_rule: 'Rule',
    col_action: 'Action',
    col_interval: 'Frequency',
    col_status: 'Status',
    col_last_run: 'Last run',
    col_actions: 'Actions',
    run_now: 'Run now',
    executions: 'Execution history',
    edit: 'Edit',
    delete: 'Delete',
    empty_title: 'No automation rules yet',
    empty_desc: 'Turn waste patterns spotted in ad checkups into rules — the system runs them daily/hourly automatically',
    matched_count: 'Matched {count}',
    dialog_create_title: 'New rule',
    dialog_edit_title: 'Edit rule',
    form_name: 'Rule name',
    form_name_placeholder: 'e.g. Auto-pause after $50 spend in 7 days with no conversions',
    form_desc: 'Note',
    form_desc_placeholder: 'Optional — describe the rule\'s purpose',
    form_conditions: 'Trigger conditions (all must match)',
    day_1: '1 day',
    day_3: '3 days',
    day_7: '7 days',
    day_14: '14 days',
    day_30: '30 days',
    add_condition: 'Add condition',
    form_action: 'Action',
    form_budget_pct: 'Budget change ratio',
    budget_safety_hint: 'Safety guard: max ±50% per change, never drops daily budget below $5',
    form_note: 'Note message (optional)',
    form_note_placeholder: 'e.g. CPA is high, observe for 3 days before acting',
    form_status: 'Status',
    status_simulate_opt: 'Simulate (try for a week first, recommended)',
    status_enabled_opt: 'Enabled',
    status_disabled_opt: 'Disabled',
    form_eval_interval: 'Evaluation frequency',
    interval_daily_opt: 'Daily',
    interval_hourly_opt: 'Hourly (intensive monitoring)',
    backtest_title: '30-day backtest',
    backtest_run: 'Run now',
    backtest_empty: 'After adjusting conditions, the past 30 days are auto-simulated to show "what would happen if this were on"',
    backtest_loading: 'Backtesting...',
    backtest_matched: 'Ads matched',
    backtest_saved: 'Potential savings',
    backtest_chart_label: 'Daily matches over the last 30 days',
    backtest_chart_tip: '{date} · matched {matched} · evaluated {evaluated}',
    backtest_recent: 'Recent matches (Top 5)',
    cancel: 'Cancel',
    create_btn: 'Create',
    save_btn: 'Save',
    exec_drawer_title: 'Execution history · {name}',
    exec_col_result: 'Result',
    exec_col_ad: 'Ad',
    exec_col_time: 'Time',
    exec_col_evidence: 'Evidence',
    metric_spend: 'Spend ($)',
    metric_impressions: 'Impressions',
    metric_clicks: 'Clicks',
    metric_conversions: 'Conversions',
    metric_purchases: 'Purchases',
    metric_purchase_value: 'Purchase value ($)',
    metric_ctr: 'CTR (rate)',
    metric_cpc: 'CPC ($)',
    metric_cpm: 'CPM ($)',
    metric_cpa: 'CPA ($)',
    metric_roas: 'ROAS (x)',
    metric_poas: 'Real POAS (profit/spend)',
    metric_true_roas: 'Real ROAS (net revenue/spend)',
    metric_net_revenue: 'Real net revenue ($)',
    metric_gross_profit: 'Real gross profit ($)',
    metric_frequency: 'Frequency',
    action_pause: 'Pause ad',
    action_notify: 'Notify only',
    action_raise_budget: 'Raise budget',
    action_lower_budget: 'Lower budget',
    status_enabled: 'Enabled',
    status_disabled: 'Disabled',
    status_simulate: 'Simulate',
    interval_hourly: 'Hourly',
    interval_daily: 'Daily',
    result_matched_simulated: 'Matched (simulated)',
    result_success: 'Executed',
    result_failed: 'Failed',
    result_skipped_duplicate: 'Skipped (cooling down)',
    cond_summary: '{metric} {comp} {threshold} ({days}d)',
    never_run: 'Never run',
    rel_minutes: '{count} min ago',
    rel_hours: '{count} h ago',
    rel_days: '{count} d ago',
    msg_load_failed: 'Load failed',
    msg_max_conditions: 'Up to 8 conditions',
    msg_min_conditions: 'Keep at least 1 condition',
    msg_name_required: 'Please enter a rule name',
    msg_created: 'Created',
    msg_updated: 'Updated',
    msg_save_failed: 'Save failed',
    msg_backtest_failed: 'Backtest failed',
    msg_status_switched: 'Switched to {status}',
    msg_update_failed: 'Update failed',
    msg_run_result: 'Done · evaluated {evaluated} ad(s) · matched {matched} · applied {applied}',
    msg_run_result_failed: ' · failed {failed}',
    msg_run_failed: 'Run failed',
    confirm_delete: 'Delete rule "{name}"? Execution history is deleted too and cannot be recovered.',
    confirm_delete_title: 'Delete rule',
    confirm_delete_label: 'Delete',
    msg_deleted: 'Deleted',
    msg_delete_failed: 'Delete failed',
    msg_load_exec_failed: 'Failed to load history',
  },
  autopilotActions: {
    title: 'Autopilot action queue',
    subtitle: 'Pending actions identified by the system — approval mode requires manual approval, auto mode executes directly. All actions are reversible.',
    refresh: 'Refresh',
    status_placeholder: 'Status',
    status_pending: 'Pending',
    status_approved: 'Approved',
    status_rejected: 'Rejected',
    status_executing: 'Executing',
    status_completed: 'Completed',
    status_failed: 'Failed',
    status_rolled_back: 'Rolled back',
    policy_placeholder: 'Policy',
    search: 'Search',
    reset: 'Reset',
    col_time: 'Time',
    col_status: 'Status',
    col_action: 'Action',
    col_policy: 'Policy',
    col_target: 'Target',
    col_reason: 'Reason',
    col_actions: 'Actions',
    target_product: 'Product: {name}',
    target_ad: 'Ad: {name}',
    approve: 'Approve',
    reject: 'Reject',
    rollback: 'Roll back',
    detail: 'Details',
    need_operator: 'Requires operator role or above',
    need_admin: 'Rollback requires admin role',
    empty_title: 'Queue is empty',
    empty_desc: 'No matching actions. Configure rules under "Policies" or click "Run policy" on the dashboard to evaluate now.',
    action_create_campaign: 'Create campaign',
    action_create_ad_set: 'Create ad set',
    action_create_ad: 'Create ad',
    action_pause_campaign: 'Pause campaign',
    action_pause_ad_set: 'Pause ad set',
    action_pause_ad: 'Pause ad',
    action_resume_campaign: 'Resume campaign',
    action_resume_ad_set: 'Resume ad set',
    action_resume_ad: 'Resume ad',
    action_increase_budget: 'Increase budget',
    action_decrease_budget: 'Decrease budget',
    drawer_title: 'Action details',
    d_action: 'Action: ',
    d_status: 'Status: ',
    d_policy: 'Policy: ',
    d_rule: 'Rule: ',
    d_target: 'Target: ',
    d_target_product: 'Product · {name}',
    d_target_ad: 'Ad · {name}',
    d_reason: 'Reason: ',
    d_error: 'Error: ',
    d_before: 'Before state: ',
    d_after: 'After state: ',
    timeline: 'Timeline',
    msg_load_failed: 'Load failed',
    msg_approved: 'Approved and executed',
    msg_exec_failed: 'Execution failed',
    msg_action_failed: 'Action failed',
    confirm_reject: 'Reject this action? It will be marked rejected and won\'t reappear.',
    confirm_reject_label: 'Reject',
    msg_rejected: 'Rejected',
    confirm_rollback: 'Roll back this action? It restores the Meta status/budget per the before-state.',
    confirm_rollback_label: 'Roll back',
    msg_rolled_back: 'Rolled back',
    msg_rollback_failed: 'Rollback failed',
  },
  targetingPacks: {
    new: 'New pack',
    new_title: 'New targeting pack',
    edit_title: 'Edit targeting pack',
    f_name: 'Name',
    name_ph: 'e.g. Core US/EU · 25-45 female',
    f_geo: 'Countries / regions',
    geo_ph: 'Select or type country codes',
    f_age_min: 'Min age',
    f_age_max: 'Max age',
    f_genders: 'Genders',
    gender_male: 'Male',
    gender_female: 'Female',
    genders_help: 'Leave empty = all genders',
    f_interests: 'Interests (optional)',
    interests_ph: 'Comma-separated, e.g. Fitness, Yoga',
    msg_saved: 'Targeting pack saved',
    msg_save_failed: 'Save failed',
    msg_deleted: 'Targeting pack deleted',
    msg_delete_failed: 'Delete failed',
    confirm_delete: 'Delete targeting pack "{name}"?',
    err_name_required: 'Pack name is required',
    err_geo_required: 'Select at least one country/region',
    err_age_range: 'Max age must be ≥ min age',
  },
  autopilotPolicies: {
    backtest: 'Backtest',
    f_max_frequency: 'Max frequency for scaling',
    f_max_frequency_tip: "When an ad set's frequency (impressions/reach) reaches this value, the scaling rule stops increasing budget to avoid burning spend on fatigued creative. Leave empty to disable.",
    f_max_frequency_off: 'No limit',
    bt_title: 'Backtest: {name}',
    bt_days: 'Days',
    bt_run: 'Run backtest',
    bt_hint: 'Replays this policy over historical data to show which scale/pause actions it would have taken — nothing is actually executed.',
    bt_scale_up: 'Scale-ups',
    bt_pause_loss: 'Loss pauses',
    bt_pause_fatigue: 'Fatigue pauses',
    bt_spend_saved: 'Est. spend saved',
    bt_range: 'Range {from} – {to} · {count} entities evaluated',
    bt_col_date: 'Date',
    bt_col_action: 'Action',
    bt_col_entity: 'Entity',
    bt_col_reason: 'Reason',
    bt_action_scale: 'Scale up',
    bt_action_pause_loss: 'Pause (loss)',
    bt_action_fatigue: 'Pause (fatigue)',
    bt_ad: 'Ad',
    bt_adset: 'Ad set',
    bt_empty_title: 'No actions in range',
    bt_empty_desc: 'This policy would not have triggered any scale or pause actions in the selected range.',
    bt_close: 'Close',
    bt_failed: 'Backtest failed',
    title: 'Autopilot policies',
    subtitle: 'One policy = one bot — binds an ad account + a store connection, and the system identifies product opportunities, cuts losses, and scales daily by rules',
    refresh: 'Refresh',
    create: 'New policy',
    create_admin_only: 'Only admins can create policies',
    empty_title: 'No Autopilot policies yet',
    empty_desc: 'Create a policy by selecting an ad account + commerce connection + rules. We recommend "Approval mode" for 1-2 weeks before switching to auto mode.',
    status_active: 'Active',
    auto_paused: '⚠ Auto-paused',
    auto_paused_tip: 'Auto-paused by the system at {time}. Trigger: 3 cumulative execution failures within 6 hours. It auto-retries after a 24-hour cooldown; you can also switch it back to "Active" now to resume immediately.',
    status_paused: 'Paused',
    status_archived: 'Archived',
    mode_auto: 'Auto mode',
    mode_approval: 'Approval mode',
    meta_account: 'Ad account: {account} · Store: {shop}',
    meta_poas: 'Target POAS: {poas} · Per-product budget cap: {cap}',
    cap_unlimited: 'Unlimited',
    toggle_admin_only: 'Only admins can pause/resume',
    edit_admin_only: 'Only admins can edit',
    delete_admin_only: 'Only admins can delete',
    rule_new_product: 'New product test',
    rule_pause_loss: 'Cut losses',
    rule_pause_unavailable: 'Pause out-of-stock',
    rule_scale_winners: 'Scale winners',
    rule_pause_fatigue: 'Pause fatigue',
    sync_products: 'Sync products now',
    created_at: 'Created {date}',
    last_evaluated: '· Last evaluated {date}',
    dialog_edit_title: 'Edit policy',
    dialog_create_title: 'New policy',
    f_name: 'Policy name',
    f_mode: 'Execution mode',
    f_desc: 'Description',
    f_ad_account: 'Ad account',
    f_commerce: 'Commerce connection',
    f_target_poas: 'Target POAS',
    f_account_cap: 'Account daily budget cap (USD)',
    f_per_product_cap: 'Per-product daily budget cap (USD)',
    creator_divider: 'Default settings for auto-created ads',
    creator_alert_title: 'Optional — built-in defaults are used when unset',
    creator_alert_desc: 'When the new-product-test rule triggers, the system auto-creates ads. Specify the FB page / pixel / template to use here; new ads are created "paused" and need approval or manual enabling.',
    f_default_page: 'Default FB page',
    f_default_page_placeholder: 'Use the workspace\'s first',
    f_default_pixel: 'Default conversion pixel',
    f_default_pixel_placeholder: 'Use the account\'s first pixel',
    rules_divider: 'Rules',
    rule_new_product_desc: 'Within listing age + inventory/margin met → generate a test ad draft',
    rnp_age: 'Listing age ≤',
    rnp_budget: 'Daily budget (USD)',
    rnp_inventory: 'Min inventory',
    rnp_margin: 'Min margin (0-1)',
    rule_pause_loss_desc: 'Spend over threshold but POAS below threshold for N consecutive days → pause ad',
    rpl_spend: 'Cumulative spend ≥',
    rpl_poas: 'POAS below',
    rpl_days: 'Consecutive days',
    rule_pause_unavailable_desc: 'Product inventory below threshold → auto-pause its live ads',
    rpu_inventory: 'Inventory ≤',
    rule_scale_winners_desc: 'POAS consistently met → raise budget (with cap protection)',
    rsw_poas: 'POAS ≥',
    rsw_days: 'Consecutive days',
    rsw_ratio: 'Increase per step (0-1)',
    rsw_max_budget: 'Max daily budget',
    rule_pause_fatigue_desc: 'Frequency too high or CTR drop too large → pause and refresh creative',
    rpf_frequency: 'Frequency ≥',
    rpf_ctr_drop: 'CTR drop ≥ (0-1)',
    cancel: 'Cancel',
    save: 'Save',
    msg_load_failed: 'Load failed',
    msg_name_required: 'Please enter a name',
    msg_account_required: 'Please select an ad account',
    msg_commerce_required: 'Please select a commerce connection',
    msg_updated: 'Updated',
    msg_created: 'Created',
    msg_save_failed: 'Save failed',
    msg_resumed: 'Resumed',
    msg_paused: 'Paused',
    msg_action_failed: 'Action failed',
    confirm_delete: 'Delete policy "{name}"? Existing actions are unaffected.',
    confirm_delete_label: 'Delete',
    msg_delete_failed: 'Delete failed',
    msg_synced: 'Synced {count} product(s)',
    msg_sync_failed: 'Sync failed',
  },

  acceptInvite: {
    loading: 'Verifying invitation...',
    invalid_link: 'Invalid invitation link',
    unavailable: 'Invitation unavailable',
    unavailable_default: 'Invitation unavailable',
    go_login: 'Go to login',
    join_workspace: 'Join workspace',
    invited_by_prefix: 'invited you to join as',
    invited_by_suffix: '',
    f_email: 'Email',
    f_name: 'Name',
    f_name_placeholder: 'Your name',
    f_password: 'Set password',
    f_password_placeholder: 'At least 8 characters',
    f_password_confirm: 'Confirm password',
    submit: 'Join and sign in',
    role_admin: 'Admin',
    role_operator: 'Operator',
    role_viewer: 'Viewer',
    msg_name_required: 'Please enter your name',
    msg_password_short: 'Password must be at least 8 characters',
    msg_password_mismatch: 'The two passwords do not match',
    msg_welcome: 'Welcome aboard, {name}!',
    msg_accept_failed: 'Failed to accept invitation',
  },


  pixels: {
    title: 'Pixels',
    subtitle: 'Conversion-tracking pixels / data sources, bound when creating ads. Meta + TikTok auto-sync; see the coverage table below for other channels.',
    refresh: 'Refresh',
    coverage_title: 'Channel support',
    coverage_synced: 'Synced',
    coverage_meta: 'Meta (Facebook)',
    coverage_tiktok: 'TikTok Pixel',
    coverage_google: 'Google Ads',
    coverage_google_status: 'No equivalent concept (uses Conversion Action)',
    coverage_pinterest: 'Pinterest Conversion Tag',
    coverage_pinterest_status: 'Synced (requires ads:read scope)',
    coverage_microsoft: 'Microsoft Ads',
    coverage_microsoft_status: 'Planned (UET Tag)',
    search_placeholder: 'Search pixel name',
    platform_placeholder: 'Channel',
    search: 'Search',
    reset: 'Reset',
    col_name: 'Name',
    col_platform: 'Channel',
    col_ad_account: 'Ad account',
    col_status: 'Status',
    col_pixel_id: 'Pixel ID',
    col_synced_at: 'Last synced',
    status_active: 'Active',
    copied: 'Copied',
    copy_failed: 'Copy failed',
    empty_filtered: 'No matching pixels',
    empty_title: 'No pixels synced yet',
    empty_desc: 'After authorizing and syncing, pixels under your ad accounts appear here',
    load_failed: 'Load failed',
  },

  reportCenter: {
    title: 'Report Center',
    subtitle: 'Save, organize and share profit report configs with your team',
    refresh: 'Refresh',
    foldersTitle: 'Folders',
    railMine: 'My Reports',
    railShared: 'Shared With Me',
    railUnfiled: 'Unfiled',
    folderNew: 'New Folder',
    folderRename: 'Rename',
    folderDelete: 'Delete',
    folderNamePrompt: 'Enter a folder name',
    folderNamePlaceholder: 'Folder name',
    folderNameRequired: 'Folder name is required',
    folderCreated: 'Folder created',
    folderCreateFailed: 'Failed to create folder',
    folderRenamed: 'Folder renamed',
    folderRenameFailed: 'Failed to rename folder',
    folderDeleteConfirm: 'Delete folder "{name}"? Its reports become unfiled.',
    folderDeleted: 'Folder deleted',
    folderDeleteFailed: 'Failed to delete folder',
    countLabel: '{count} reports',
    emptyTitle: 'No saved reports yet',
    emptyDesc: 'Save a config from the Profit report via "Save as report"',
    open: 'Open',
    share: 'Share',
    unshare: 'Unshare',
    shared: 'Shared with the team',
    unshared: 'Sharing removed',
    shareFailed: 'Action failed',
    sharedTag: 'Shared',
    delete: 'Delete',
    deleteConfirm: 'Delete report "{name}"?',
    deleted: 'Report deleted',
    deleteFailed: 'Failed to delete report',
    loadFailed: 'Failed to load reports',
    type_profit: 'Profit Dashboard',
    type_drilldown: 'Drill-down',
    type_product: 'By Product',
    type_creative: 'By Creative',
    type_custom: 'Custom',
    saveAs: 'Save as report',
    saveDialogTitle: 'Save as report',
    nameLabel: 'Report name',
    namePlaceholder: 'Name this report config',
    nameRequired: 'Report name is required',
    folderLabel: 'Folder',
    folderNone: 'No folder',
    shareWithTeam: 'Share with team',
    saved: 'Report saved',
    saveFailed: 'Failed to save report',
    builtin: {
      sectionTitle: 'Built-in Reports',
      groupCommon: 'Common Dashboards',
      groupCreative: 'Creative Analysis',
      groupCommerce: 'Products & Stores',
      groupChannel: 'Channel-Specific',
      groupCustom: 'Custom',
      unavailableTag: 'Not connected',
      unavailable_channel: 'Available after the {channel} channel is connected and verified',
      unavailable_feature: 'This report is in development and coming in a later release',
      // Sample dashboards
      optimizerEfficiency_name: 'Optimizer Efficiency',
      optimizerEfficiency_desc: 'Output and efficiency by optimizer / designer',
      channelPerformance_name: 'Ad Performance',
      channelPerformance_desc: 'Spend, impressions, clicks, conversions and ROAS across channels',
      pivotMatrix_name: 'Pivot Report',
      pivotMatrix_desc: 'Drill down account / campaign / ad set / ad performance',
      googleReport_name: 'Google Report',
      googleReport_desc: 'Google Ads delivery overview',
      tiktokShop_name: 'TikTok Shop Report',
      tiktokShop_desc: 'TikTok Shop sales performance',
      tiktokSpu_name: 'TikTok SPU Report',
      tiktokSpu_desc: 'TikTok performance by SPU',
      tiktokBidStrategy_name: 'TikTok Bid Strategy Report',
      tiktokBidStrategy_desc: 'Delivery performance grouped by bid strategy',
      googleBidType_name: 'Google Bid Type Report',
      googleBidType_desc: 'Delivery performance grouped by bid type',
      metaObjective_name: 'Meta Objective Report',
      metaObjective_desc: 'Drill real profit down by Meta objective',
      tiktokPost_name: 'TikTok Post Dashboard',
      tiktokPost_desc: 'TikTok post / creative dimension dashboard',
      // System dashboards
      comprehensive_name: 'Business Overview',
      comprehensive_desc: 'Overall real profit / POAS, pace and channel mix',
      productReport_name: 'Product Report',
      productReport_desc: 'Last 30 days real profit and POAS ranking per product',
      storeReport_name: 'Store Report',
      storeReport_desc: 'Sales and real profit per store',
      creativeBoard_name: 'Creative Dashboard',
      creativeBoard_desc: 'Unified view for creative assets, top creatives and tag performance',
      customBoard_name: 'Custom Dashboard',
      customBoard_desc: 'Pivot real profit by any dimension + metrics',
    },
  },
  profitReport: {
    compare_off: 'No compare',
    compare_prev: 'Prev period',
    compare_yoy: 'Year over year',
    compare_tooltip: 'Comparison range: {start} → {end}',
    compare_tooltip_off: 'Pick a comparison period to show Δ%',
    pace_today: 'Today spend',
    pace_yesterday: 'Yesterday spend',
    pace_7d: 'Last 7d spend',
    pace_14d: 'Last 14d spend',
    pace_poas: 'POAS {value}',
    pace_no_spend: 'No spend',
    donut_title: 'Spend share by channel',
    donut_name: 'Spend share',
    donut_empty: 'No channel spend data',
    donut_unknown: 'Unknown',
    totals_label: 'Totals',
    columns_btn: 'Columns',
    columns_title: 'Show columns',
  },
  storeReport: {
    title: 'Store Report',
    subtitle: 'Sales, refunds, COGS and real gross profit aggregated per store',
    refresh: 'Refresh',
    preset_7d: 'Last 7d',
    preset_30d: 'Last 30d',
    preset_90d: 'Last 90d',
    preset_month: 'This month',
    start_date: 'Start date',
    end_date: 'End date',
    totals_label: 'Total',
    col_stores: 'Stores',
    col_store: 'Store',
    col_orders: 'Orders',
    col_gross_revenue: 'Gross revenue',
    col_refund: 'Refunds',
    col_cogs: 'COGS',
    col_net_revenue: 'Net revenue',
    col_gross_profit: 'Real gross profit',
    mixed_currency_note: 'Mixed currencies — money totals hidden (each row shown in its own currency)',
    empty_title: 'No store sales data yet',
    empty_desc: 'Once you connect a store and sync orders, sales and real profit will roll up here per store',
    load_failed: 'Failed to load store report',
  },
  breakdown: {
    title: 'Breakdowns',
    subtitle: 'Platform metrics split by placement/region/device/age/gender',
    refresh: 'Refresh',
    platform_only_note: 'Platform-side metrics are split by dimension. Real-profit POAS CANNOT be split this way — orders are attributed to the ad and carry no placement/region/device/age/gender.',
    dim_placement: 'Placement',
    dim_region: 'Region',
    dim_device: 'Device',
    dim_age: 'Age',
    dim_gender: 'Gender',
    preset_7d: '7d',
    preset_30d: '30d',
    preset_90d: '90d',
    preset_month: 'This month',
    start_date: 'Start date',
    end_date: 'End date',
    chart_title: 'Spend by dimension (Top 12)',
    totals_label: 'Total',
    col_value: 'Value',
    col_spend: 'Spend',
    col_impressions: 'Impr.',
    col_clicks: 'Clicks',
    col_conversions: 'Conv.',
    col_purchase_value: 'Platform revenue',
    col_platform_roas: 'Platform ROAS',
    empty_title: 'No breakdown data',
    empty_desc: 'Breakdown data comes from real FB ad sync; connect an ad account and sync to populate.',
    load_failed: 'Failed to load',
  },
  aiAssistant: {
    nl_build_btn: 'AI Build Rule',
    nl_dialog_title: 'Describe your rule in one sentence',
    nl_hint: 'Describe in natural language, e.g. "pause ads whose POAS is below 0.8 for 3 days straight". AI parses it into a rule for you to confirm before saving.',
    nl_placeholder: 'e.g. Pause ads with POAS below 0.8 for 3 consecutive days',
    nl_parse_btn: 'Parse',
    nl_input_required: 'Please enter at least 2 characters',
    nl_parsed: 'Parsed — please review and save',
    nl_parse_failed: 'Parse failed',
    page_title: 'AI Assistant',
    page_subtitle: 'Smart diagnosis and auto daily review, all grounded in your real spend and profit data',
    diag_title: 'Smart Diagnosis',
    diag_pick_campaign: 'Please select a campaign',
    diag_pick_range: 'Please select a date range',
    diag_failed: 'Diagnosis failed',
    diag_campaign_ph: 'Select campaign',
    diag_start: 'Start date',
    diag_end: 'End date',
    diag_run: 'Diagnose',
    col_metric: 'Metric',
    col_current: 'Current',
    col_previous: 'Previous',
    col_delta: 'Δ',
    m_spend: 'Spend',
    m_gross_profit: 'Gross profit',
    m_poas: 'POAS',
    m_true_roas: 'True ROAS',
    m_ctr: 'CTR',
    m_cpa: 'CPA',
    m_orders: 'Orders',
    causes: 'Likely causes',
    actions: 'Recommended actions',
    model_cost: 'Model: {model} · est. cost ${cost}',
    review_title: 'Auto Daily Review',
    review_refresh: 'Refresh',
    review_generate: 'Generate',
    review_generated: 'Report generated',
    review_failed: 'Generation failed',
    review_for: 'Review for {date}',
    review_empty: 'No review yet. Click "Generate" to build one from yesterday\'s real data.',
    movers_up: 'Top movers up',
    movers_down: 'Wasted spend / down',
    anomalies: 'Anomalies',
    suggested: 'Suggested actions',
  },
  tags: {
    manage: 'Manage Tags',
    modeTagReport: 'Tag Report',
    newGroup: 'New Group',
    newChild: 'New Sub-tag',
    nameLabel: 'Tag name',
    nameRequired: 'Tag name is required',
    dimensionLabel: 'Dimension (e.g. format/angle)',
    created: 'Tag created',
    createFailed: 'Failed to create tag',
    editKeywords: 'Edit Keywords',
    keywordsHint: 'Match keywords, comma/newline separated (empty = match by name)',
    saved: 'Saved',
    saveFailed: 'Save failed',
    delete: 'Delete',
    deleteConfirm: 'Delete tag "{name}"? (Tags already on creatives are kept)',
    deleted: 'Tag deleted',
    deleteFailed: 'Delete failed',
    import: 'Bulk Import',
    importHint: 'One per line: type<Tab>parent<Tab>name<Tab>keywords',
    importEmpty: 'No rows to import',
    imported: 'Imported: {created} added, {skipped} skipped',
    importFailed: 'Import failed',
    applyAuto: 'Auto-tag',
    autoApplied: 'Auto-tag done: {matched} matched, {applied} applied',
    autoApplyFailed: 'Auto-tag failed',
    emptyTitle: 'No tags yet',
    emptyDesc: 'Create groups and sub-tags to organize creatives',
    drillDown: 'Drill-down',
    reportEmptyTitle: 'No tag report data',
    reportEmptyDesc: 'Tag creatives and ensure delivery data exists',
    colTagType: 'Type',
    colTag: 'Tag',
    colCreatives: 'Creatives',
  },
  scheduledReport: {
    schedule: 'Schedule',
    dialogTitle: 'Scheduled delivery · {name}',
    existing: 'Existing schedules',
    frequency: 'Frequency',
    freq_daily: 'Daily',
    freq_weekly: 'Weekly',
    freq_monthly: 'Monthly',
    hourUtc: 'Send time (UTC hour)',
    weekday: 'Weekday',
    dayOfMonth: 'Day of month',
    wd_0: 'Sun',
    wd_1: 'Mon',
    wd_2: 'Tue',
    wd_3: 'Wed',
    wd_4: 'Thu',
    wd_5: 'Fri',
    wd_6: 'Sat',
    channels: 'IM channels',
    channelsPlaceholder: 'Select Feishu / DingTalk / WeCom / Webhook channels',
    noChannels: 'No channels yet — add one in Notification Settings first',
    emails: 'Email recipients',
    emailsPlaceholder: 'Separate multiple emails with comma, space or semicolon',
    destSummary: '{channels} channels · {emails} emails',
    needDestination: 'Pick at least one channel or enter an email',
    add: 'Add schedule',
    save: 'Save',
    cancelEdit: 'Cancel edit',
    edit: 'Edit',
    pause: 'Pause',
    resume: 'Resume',
    delete: 'Delete',
    runNow: 'Run now',
    ranNow: 'Sent · {channels} channels · {emails} emails',
    runFailed: 'Run failed',
    created: 'Schedule created',
    updated: 'Schedule updated',
    deleted: 'Schedule deleted',
    saveFailed: 'Save failed',
    deleteFailed: 'Delete failed',
    deleteConfirm: 'Delete this scheduled delivery?',
  },
  assetPacks: {
    geo_groups: 'Geo groups',
    creative_groups: 'Creative groups',
    keyword_packages: 'Keyword packs',
    save_geo: 'Save as geo group',
    save_creative: 'Save as creative group',
    new_keyword: 'New keyword pack',
    save_geo_title: 'Save geo group',
    save_creative_title: 'Save creative group',
    save_keyword_title: 'Save keyword pack',
    name_prompt: 'Name this asset pack',
    keywords_prompt: 'Enter keywords, comma- or newline-separated',
    applied_geo: 'Applied geo group "{name}" ({n} countries)',
    applied_creative: 'Applied creative group "{name}" ({n} creatives)',
    msg_saved: 'Saved',
    msg_save_failed: 'Save failed',
    msg_deleted: 'Deleted',
    msg_delete_failed: 'Delete failed',
    confirm_delete: 'Delete "{name}"?',
    err_name_required: 'Name is required',
    err_geo_empty: 'Select geos first',
    err_creative_empty: 'Select creatives first',
    err_keywords_required: 'Enter at least one keyword',
  },
  onlineBatchEdit: {
    entry: 'Online batch edit',
    title_campaigns: 'Online batch edit · Campaigns',
    title_adsets: 'Online batch edit · Ad sets',
    title_ads: 'Online batch edit · Ads',
    step_edit: 'Edit',
    step_preview: 'Dry-run preview',
    step_execute: 'Execute',
    meta: '{count} selected',
    meta_skipped: '{count} unsupported, will be skipped',
    assign_label: 'Fill all',
    assign_status_ph: 'Status',
    assign_budget_ph: 'Daily budget',
    assign_bid_ph: 'Bid',
    assign_factor_ph: 'Factor',
    assign_apply: 'Fill',
    status_on: 'On',
    status_off: 'Off',
    tag_unsupported: 'Unsupported',
    col_name: 'Name',
    col_status: 'Status',
    col_budget: 'Daily budget',
    col_bid: 'Bid',
    col_changes: 'Changes',
    col_op: 'Op',
    col_result: 'Result',
    col_error: 'Error',
    no_writable: 'No editable rows (unsupported channel)',
    no_changes: 'No changes made',
    dry_run_btn: 'Dry-run preview',
    preview_failed: 'Preview failed',
    summary: 'Total {total} · changed {changed} · errors {errors} · unchanged {no_change}',
    has_errors: '{count} rows failed validation and will be excluded',
    no_change_cell: 'No change',
    back: 'Back',
    execute_btn: 'Execute {count} change(s)',
    execute_failed: 'Submit failed',
    confirm_title: 'Confirm execution',
    confirm_message: 'Submit batch edits for {count} entities. Continue?',
    confirm_ok: 'Execute',
    job_name: 'Online batch edit {level} · {time}',
    level_campaign: 'Campaign',
    level_adset: 'Ad set',
    level_ad: 'Ad',
    exec_counts: 'Done {done}/{total} · failed {failed} · skipped {skipped}',
    polling: 'Refreshing',
    retry_btn: 'Retry failed',
    retry_failed: 'Retry failed',
    cancel: 'Cancel',
    close: 'Close',
    item_status_pending: 'Pending',
    item_status_updating: 'Updating',
    item_status_done: 'Done',
    item_status_failed: 'Failed',
    item_status_skipped: 'Skipped',
    job_status_pending: 'Pending',
    job_status_running: 'Running',
    job_status_partial: 'Partial',
    job_status_done: 'Done',
    job_status_failed: 'Failed',
    job_status_cancelled: 'Cancelled',
  },
  customReport: {
    title: 'Custom Dashboard',
    subtitle: 'Pivot real-profit data by any dimension; save as a report',
    refresh: 'Refresh',
    saveAs: 'Save as custom report',
    dimensionLabel: 'Dimension',
    metricsLabel: 'Metrics',
    metricsPlaceholder: 'Select metrics',
    filterPlaceholder: 'Filter by name',
    showChart: 'Show chart',
    chartTitle: 'Top 12 by gross profit',
    mixed_currency: 'Multiple currencies present; showing {currency} only',
    load_failed: 'Failed to load',
    empty_title: 'No data',
    empty_desc: 'Adjust the dimension or date range and retry',
    dim_account: 'Account',
    dim_campaign: 'Campaign',
    dim_adset: 'Ad set',
    dim_ad: 'Ad',
    dim_product: 'Product',
    dim_creative: 'Creative',
    metric_spend: 'Spend',
    metric_net_revenue: 'Net revenue',
    metric_gross_profit: 'Gross profit',
    metric_order_count: 'Orders',
    metric_poas: 'POAS',
    metric_true_roas: 'True ROAS',
    metric_platform_roas: 'Platform ROAS',
  },
  profitDashboard: {
    title: 'Business Overview',
    subtitle: 'Align ad-channel ROAS with Shopify\'s real orders / refunds / gross profit — see which channels make you money and which burn it',
    start_date: 'Start date',
    end_date: 'End date',
    refresh: 'Refresh',
    export_csv: 'Export CSV',
    export_empty: 'No data to export for this range',
    preset_today: 'Today',
    preset_yesterday: 'Yesterday',
    preset_7d: 'Last 7 days',
    preset_30d: 'Last 30 days',
    preset_90d: 'Last 90 days',
    preset_month: 'This month',
    preset_last_month: 'Last month',
    compare_switch: 'vs previous period',
    compare_tooltip: 'Comparing {start} ~ {end}',
    compare_tooltip_auto: 'Compare against the previous equal-length period (↑↓%)',
    series_poas: 'POAS',
    series_true_roas: 'True ROAS',
    series_platform_roas: 'Channel ROAS',
    axis_money: 'Amount',
    axis_roas: 'ROAS',
    kpi_spend: 'Ad spend',
    kpi_orders: 'Orders',
    kpi_net_revenue: 'Net revenue',
    kpi_gross_profit: 'Gross profit',
    kpi_margin: 'Margin {pct}',
    kpi_platform_roas: 'Channel ROAS',
    kpi_platform_roas_hint: 'Ad-platform figure',
    kpi_poas: 'POAS · True profit ROAS',
    kpi_true_roas: 'True ROAS {value}',
    gap_title: 'True ROAS is only {pct} of channel ROAS',
    gap_body: 'The channel reports {platform}, but your bank account only sees {true} — likely due to refunds / discounts / cross-channel double attribution. Check discount codes and "remarketing" campaigns.',
    chart_title: 'Daily trend — Spend / Revenue / Profit',
    series_spend: 'Ad spend',
    series_net_revenue: 'Net revenue',
    series_gross_profit: 'Gross profit',
    chart_empty_title: 'No daily data',
    chart_empty_desc: 'Confirm there is ad spend and store orders in the selected range — if Shopify isn\'t connected yet, go connect it under "Stores"',
    detail_title: 'Daily breakdown',
    col_date: 'Date',
    col_spend: 'Spend',
    col_orders: 'Orders',
    col_net_revenue: 'Net revenue',
    col_gross_profit: 'Gross profit',
    col_platform_roas: 'Channel ROAS',
    col_true_roas: 'True ROAS',
    col_poas: 'POAS',
    table_empty_title: 'No data in the selected range',
    table_empty_desc: 'Widen the range or connect Shopify under "Stores" first',
    load_failed: 'Load failed',
    byAd: {
      title: 'By ad · Real profit',
      caption:
        'True POAS = gross profit ÷ spend (after COGS/refunds) — closer to what you actually earn than platform ROAS.',
      info_tooltip:
        'v1 attribution is "last click + ads with injected UTM" (ads built via Bulk Create); legacy ads / ads without UTM are not in this table. COGS is a ratio / per-order cost (per-product per-order cost lands in v1.1).',
      mixed_currency:
        'Some accounts/stores use different currencies; shown in the primary currency ({currency}), the rest are excluded.',
      col_ad: 'Ad',
      col_campaign: 'Campaign',
      col_platform: 'Platform',
      col_spend: 'Spend',
      col_orders: 'Orders',
      col_net_revenue: 'True net revenue',
      col_gross_profit: 'True gross profit',
      col_poas: 'True POAS',
      col_true_roas: 'True ROAS',
      col_platform_roas: 'Platform ROAS',
      empty_title: 'No per-ad real profit yet',
      empty_desc:
        'Per-ad attribution needs ads built via Bulk Create with UTM tracking + synced store orders. Build tracked ads via Bulk Create and connect / sync your store orders.',
    },
    byProduct: {
      title: 'By product · Real profit',
      caption:
        'Product-level real profit (after COGS/refunds) — which product actually makes money from ads. XMP e-commerce edition does not have this.',
      info_tooltip:
        'Product attribution relies on the product UTM marker injected by Bulk Create + synced store orders; ads without the marker / legacy ads are not in this table. COGS is a ratio / per-order cost (per-product per-order cost lands in v1.1).',
      mixed_currency:
        'Some accounts/stores use different currencies; shown in the primary currency ({currency}), the rest are excluded.',
      col_product: 'Product',
      col_ads: 'Ads',
      col_spend: 'Spend',
      col_orders: 'Orders',
      col_net_revenue: 'True net revenue',
      col_gross_profit: 'True gross profit',
      col_poas: 'True POAS',
      col_true_roas: 'True ROAS',
      empty_title: 'No per-product real profit yet',
      empty_desc:
        'Per-product profit needs ads built via Bulk Create with the product UTM marker injected + synced store orders. Build tracked ads via Bulk Create and connect / sync your store orders.',
    },
  },

  profitDrilldown: {
    title: 'Drill-down Analysis',
    subtitle: 'Drill account→campaign→adset→ad — every level is real profit (COGS/refunds deducted). XMP only has platform ROAS.',
    refresh: 'Refresh',
    start_date: 'Start date',
    end_date: 'End date',
    preset_today: 'Today',
    preset_yesterday: 'Yesterday',
    preset_7d: 'Last 7 days',
    preset_30d: 'Last 30 days',
    preset_90d: 'Last 90 days',
    preset_month: 'This month',
    preset_last_month: 'Last month',
    root_crumb: 'All accounts',
    level_account: 'Account',
    level_campaign: 'Campaign',
    level_adset: 'Ad set',
    level_ad: 'Ad',
    drill_hint: 'Drill in',
    mixed_currency: 'Some accounts/shops use different currencies; shown in the primary currency ({currency}), the rest excluded.',
    col_name: 'Name',
    col_spend: 'Spend',
    col_orders: 'Orders',
    col_net_revenue: 'True net revenue',
    col_gross_profit: 'True gross profit',
    col_poas: 'True POAS',
    col_true_roas: 'True ROAS',
    col_platform_roas: 'Platform ROAS',
    empty_title: 'No data at this level',
    empty_desc: 'Needs ad spend + synced store orders. Connect / sync Shopify under "Commerce Shops" and make sure there is spend in the range.',
    load_failed: 'Load failed',
  },

  reports: {
    title: 'Ad Performance',
    subtitle: 'Cross-channel ad performance aggregation, grouped by date / channel / account / campaign with export',
    refresh_data: 'Refresh data',
    export_csv: 'Export CSV',
    preset_today: 'Today',
    preset_yesterday: 'Yesterday',
    preset_7d: 'Last 7 days',
    preset_30d: 'Last 30 days',
    preset_90d: 'Last 90 days',
    preset_month: 'This month',
    preset_last_month: 'Last month',
    range_start: 'Start',
    range_end: 'End',
    platform_all: 'All channels',
    group_date: 'By date',
    group_platform: 'By channel',
    group_ad_account: 'By account',
    group_campaign: 'By campaign',
    compare_tooltip: 'Comparison range: {start} → {end}',
    compare_tooltip_auto: 'Auto-shifts to previous period',
    compare_switch: 'Compare previous',
    kpi_spend: 'Spend',
    kpi_impressions: 'Impressions',
    kpi_clicks: 'Clicks',
    kpi_ctr: 'CTR',
    kpi_conversions: 'Conversions',
    kpi_roas: 'ROAS',
    prev_hint: 'Prev {value}',
    legend_spend: 'Spend',
    legend_clicks: 'Clicks',
    legend_conversions: 'Conversions',
    legend_spend_prev: 'Spend (prev)',
    axis_usd: 'USD',
    axis_count: 'Count',
    pie_name: 'Spend by Platform',
    card_trend: 'Trend',
    trend_date_only: 'The trend chart only shows when grouped by date.',
    card_pie: 'Channel distribution (spend)',
    detail_title: 'Detail · by {dimension}',
    dim_date: 'date',
    dim_platform: 'channel',
    dim_ad_account: 'account',
    dim_campaign: 'campaign',
    dim_default: 'dimension',
    col_name: 'Name',
    col_impressions: 'Impressions',
    col_clicks: 'Clicks',
    col_spend: 'Spend',
    col_ctr: 'CTR',
    col_cpc: 'CPC',
    col_cpm: 'CPM',
    col_conversions: 'Conversions',
    col_roas: 'ROAS',
    empty_title: 'No report data in the last 7 days',
    empty_p1_prefix: 'After connecting a channel, ad structure (accounts/campaigns) auto-syncs, but',
    empty_p1_strong: 'historical performance must be pulled separately',
    empty_p1_suffix: '— every cross-platform API runs insights through an async pipeline.',
    empty_li1: 'to dispatch an insights pull immediately (usually 1-3 min, FB is a bit slower)',
    empty_li1_strong: '"Refresh data"',
    empty_li1_prefix: 'Click',
    empty_li2: 'The system auto-pulls yesterday\'s data at 02:00 daily and refreshes today\'s data hourly',
    empty_li3_prefix: 'Visit',
    empty_li3_link: 'Channel auth',
    empty_li3_suffix: 'to see sync progress',
    empty_refresh: 'Refresh data now',
    msg_sync_dispatched: 'Sync dispatched for {count} ad account(s)',
    msg_sync_failed: 'Failed to sync reports',
    msg_load_failed: 'Failed to load reports',
    msg_not_signed_in: 'Not signed in',
    msg_export_failed: 'Export failed',
    msg_export_failed_status: 'Export failed: {status}',
  },

  campaignDetail: {
    back: 'Back',
    title_fallback: 'Campaign #{id}',
    subtitle_fallback: 'Campaign detail',
    edit: 'Edit',
    pause: 'Pause',
    resume: 'Resume',
    archive: 'Archive',
    meta_status: 'Status',
    meta_objective: 'Objective',
    meta_budget: 'Budget',
    meta_budget_type: 'Budget type',
    budget_daily: 'Daily',
    budget_lifetime: 'Lifetime',
    meta_start: 'Start',
    meta_end: 'End',
    perf_title: 'Last 7 days performance',
    perf_empty: 'No data — this campaign hasn\'t synced performance yet, or had no spend in the last 7 days',
    kpi_spend: 'Spend',
    kpi_impressions: 'Impressions',
    kpi_clicks: 'Clicks',
    kpi_ctr: 'CTR',
    kpi_conversions: 'Conversions',
    kpi_roas: 'ROAS',
    tab_adsets: 'Ad sets',
    tab_ai: 'AI review',
    tab_raw: 'Raw data',
    select_all: 'Select all',
    new_adset: 'New ad set',
    selected_count: 'Selected {count} ad set(s)',
    bulk_edit: 'Bulk edit',
    bulk_pause: 'Bulk pause',
    bulk_resume: 'Bulk resume',
    bulk_archive: 'Bulk archive',
    clear_selection: 'Clear selection',
    adset_meta: 'Budget {budget} · Bid {bid}',
    new_ad: 'New ad',
    col_ad_name: 'Ad name',
    col_status: 'Status',
    col_type: 'Type',
    col_headline: 'Headline',
    col_cta: 'CTA',
    col_actions: 'Actions',
    no_ads: 'No ads',
    empty_adsets_title: 'No ad sets yet',
    empty_adsets_desc: 'No ad sets synced under this campaign yet; try triggering a sync from the channel auth page',
    status_active: 'Active',
    status_paused: 'Paused',
    status_deleted: 'Deleted',
    status_archived: 'Archived',
    status_pending_review: 'In review',
    status_disapproved: 'Disapproved',
    confirm_destructive: '{label} "{name}"? This syncs to the channel and cannot be undone.',
    msg_done: '{label} done',
    msg_failed: '{label} failed',
    msg_load_failed: 'Load failed',
    msg_load_ads_failed: 'Failed to load ads',
    bulk_none: 'No ad sets eligible to {label}',
    bulk_done: '{label} {count} ad set(s)',
    bulk_partial: '{label}: {ok} succeeded, {failed} failed',
  },

  experiments: {
    title: 'A/B Experiment Console',
    subtitle: 'Design a hypothesis, pick variants, run enough days, get statistical significance — stop swapping creatives on a hunch',
    refresh: 'Refresh',
    new_experiment: 'New experiment',
    list_title: 'Experiments ({count})',
    empty_title: 'No experiments yet',
    empty_desc: 'Frame a hypothesis, pick 2-8 variants, run for significance, and build a playbook',
    placeholder_title: 'Pick an experiment to view its progress',
    placeholder_desc: 'Select one on the left or create a new one from the top right',
    sub_line: 'p < {p} · min {days} days',
    start: 'Start experiment',
    conclude: 'Declare winner',
    abort: 'Abort',
    delete: 'Delete',
    hypothesis_label: 'Hypothesis: {text}',
    progress_line: 'Running {days} / {min} days · ',
    ready_tag: '✓ Ready to conclude — at least one variant is significant',
    need_more_days: '{days} more day(s) to go',
    not_significant: 'Not significant yet, keep observing',
    concluded_banner: '✓ Concluded — winner: {winner}',
    winner_unspecified: 'unspecified',
    variant_comparison: 'Variant comparison',
    col_variant: 'Variant',
    tag_control: 'Control',
    target_count: '{count} target(s)',
    col_spend: 'Spend',
    col_impressions: 'Impr.',
    col_clicks: 'Clicks',
    col_conversions: 'Conv.',
    col_verdict: 'Verdict',
    dialog_title: 'New experiment',
    field_name: 'Experiment name',
    field_name_ph: 'e.g. Hook A/B: pain point vs price',
    field_scope: 'Scope',
    scope_ad_id: 'Ad ID',
    scope_adset_id: 'Ad set ID',
    scope_campaign_id: 'Campaign ID',
    field_hypothesis: 'Hypothesis',
    field_hypothesis_ph: 'e.g. A price-comparison hook lifts CTR 30% over a pain-point narrative hook',
    field_primary_metric: 'Primary metric (decides the winner)',
    metric_ctr_opt: 'CTR (click-through rate)',
    metric_conversion_rate_opt: 'Conversion rate',
    metric_cpa_opt: 'CPA (lower is better)',
    metric_roas_opt: 'ROAS',
    metric_purchase_count_opt: 'Purchases',
    field_p_value: 'p-value threshold',
    field_min_days: 'Min days',
    variants_divider: 'Variants (2 to 8)',
    variant_label_ph: 'A / B / C...',
    variant_desc_ph: 'Variant description (optional)',
    variant_targets_ph: '{scope} IDs, comma-separated',
    add_variant: 'Add variant',
    cancel: 'Cancel',
    create_draft: 'Create draft',
    variant_control_a: 'A (control)',
    msg_max_variants: 'Up to 8 variants',
    msg_min_variants: 'At least 2 variants required',
    msg_need_name: 'Please enter an experiment name',
    msg_need_hypothesis: 'Please enter a hypothesis',
    msg_need_target: 'Each variant needs at least one {scope} ID',
    msg_created: 'Experiment created (draft — click "Start" to begin collecting stats)',
    msg_create_failed: 'Create failed',
    confirm_start_msg: 'Start experiment "{name}"? Stats start accumulating now. It needs at least {days} days before a result can be declared.',
    confirm_start_title: 'Start experiment',
    confirm_start_ok: 'Start',
    msg_started: 'Started',
    msg_action_failed: 'Action failed',
    confirm_conclude_abort: 'Abort experiment "{name}"? No winner will be recorded.',
    confirm_conclude_win: 'Declare variant {label} the winner? The experiment moves to "concluded" and stops accumulating stats.',
    conclude_abort_title: 'Abort experiment',
    conclude_win_title: 'Declare winner',
    msg_aborted: 'Aborted',
    msg_concluded: 'Winner declared',
    confirm_delete: 'Delete experiment "{name}"? Its variants are deleted too.',
    delete_title: 'Delete',
    delete_confirm_label: 'Delete',
    msg_deleted: 'Deleted',
    msg_delete_failed: 'Delete failed',
    msg_load_failed: 'Load failed',
    msg_load_detail_failed: 'Failed to load details',
    status_draft: 'Draft',
    status_running: 'Running',
    status_concluded: 'Concluded',
    status_aborted: 'Aborted',
    metric_ctr: 'CTR (click-through rate)',
    metric_conversion_rate: 'Conversion rate',
    metric_cpa: 'CPA (cost per conversion, lower is better)',
    metric_roas: 'ROAS',
    metric_purchase_count: 'Purchases',
    scope_ad: 'Ad',
    scope_adset: 'Ad set',
    scope_campaign: 'Campaign',
    verdict_control: 'Control',
    verdict_winning: '✓ Winning',
    verdict_losing: '✗ Losing',
    verdict_inconclusive: 'No significant difference',
    pvalue_insufficient: '— insufficient sample',
    lift_none: '—',
  },

  diagnostics: {
    title: 'Ad Health Check',
    subtitle: 'Auto-diagnose budget-wasting ads — high spend with zero conversions, frequency too high, CTR decay, CPA anomalies, and more',
    refresh: 'Refresh',
    run_now: 'Re-analyze now',
    stat_critical: 'Critical issues',
    stat_active: 'Open issues',
    stat_wasted: 'Potential waste this week',
    stat_saved: 'Saved this month',
    tab_active: 'Open',
    tab_resolved: 'Auto-resolved',
    tab_dismissed: 'Dismissed',
    tab_all: 'All',
    severity_filter_ph: 'All severities',
    severity_critical: 'Critical',
    severity_warning: 'Warning',
    severity_info: 'Info',
    col_severity: 'Severity',
    col_problem: 'Problem',
    col_ad: 'Ad',
    col_wasted: 'Wasted budget',
    col_action: 'Suggested action',
    col_first_seen: 'First seen',
    col_actions: 'Actions',
    btn_pause: 'Pause',
    btn_view: 'View ad',
    btn_dismiss: 'Dismiss',
    empty_active_title: 'No open issues right now',
    empty_other_title: 'Nothing in this category',
    empty_active_desc: 'Every live ad is in a healthy range. The system rescans daily at 03:00, or click Re-analyze now in the top right.',
    empty_other_desc: 'Fills in automatically after the next scan',
    msg_run_done: 'Analysis done · scanned {aggregates} ads · {created} new · {updated} updated · {resolved} resolved',
    msg_load_summary_failed: 'Failed to load summary',
    msg_load_failed: 'Failed to load diagnostics',
    msg_run_failed: 'Run failed',
    confirm_dismiss: 'Dismiss the "{rule}" alert on "{ad}"? You won\'t be reminded again.',
    dismiss_title: 'Dismiss alert',
    dismiss_ok: 'Dismiss',
    msg_dismissed: 'Dismissed',
    msg_action_failed: 'Action failed',
    confirm_pause: 'Pause ad "{ad}"? This syncs to {platform} immediately and stops delivery.',
    pause_title: 'Pause',
    pause_confirm_label: 'Pause',
    msg_paused: 'Paused',
    msg_pause_failed: 'Pause failed',
    rule_high_spend_no_conv: 'High spend, zero conversions',
    rule_learning_stuck: 'Stuck in learning',
    rule_frequency_high: 'Frequency too high',
    rule_ctr_decay: 'CTR decay',
    rule_cpa_anomaly: 'CPA anomaly',
    rule_roas_below_target: 'ROAS below target',
    action_pause: 'Pause',
    action_lower_budget: 'Lower budget',
    action_replace_creative: 'Replace creative',
    action_split_audience: 'Split audience / test',
    action_observe: 'Keep observing',
    metric_high_spend_no_conv: '{spend} spent over 7 days with zero conversions',
    metric_learning_stuck: '{value} conversions / learning target {target}',
    metric_frequency_high: 'Frequency {value} (threshold {threshold})',
    metric_ctr_decay: '3-day CTR {value} · baseline {baseline}',
    metric_cpa_anomaly: '3-day CPA {value} · baseline {baseline}',
    metric_roas_below_target: '7-day ROAS {value} (target {target})',
    rel_minutes_ago: '{count} min ago',
    rel_hours_ago: '{count} h ago',
    rel_days_ago: '{count} d ago',
  },

  insightsLibrary: {
    title: 'AI Insights Library',
    subtitle: 'Claude scans all your ad changes + performance data weekly to distill reusable winning decision patterns',
    scan_now: 'Scan now',
    refresh: 'Refresh',
    filter_status_ph: 'Status: all',
    filter_type_ph: 'Type: all',
    opt_all: 'All',
    status_new: 'New',
    status_reviewed: 'Reviewed',
    status_applied: 'Applied',
    status_dismissed: 'Archived',
    type_success: 'Success pattern',
    type_failure: 'Failure pattern',
    type_recommendation: 'Recommendation',
    empty_library: 'Your library is empty — click "Scan now" and let Claude distill your winning decisions',
    empty_filtered: 'No insights match the current filters',
    confidence_high: 'High confidence',
    confidence_medium: 'Medium',
    confidence_low: 'Low confidence',
    sample_based: '📊 Based on {count} data points',
    evidence: 'Evidence',
    evidence_samples: 'Samples',
    evidence_data_points: 'Data points',
    evidence_reasons: 'Attribution',
    mark_reviewed: 'Mark reviewed',
    archive: 'Archive',
    apply_as_rule: 'Apply as rule',
    applied: 'Applied',
    view_rule: 'View rule #{id}',
    restore: 'Restore',
    delete: 'Delete',
    meta_auto: 'Generated by Weekly auto-scan · {cost}',
    meta_manual: 'Generated by Manual scan · {cost}',
    confirm_scan: 'This scan consumes some LLM tokens and usually finishes in 30-60 seconds. Continue?',
    scan_title: 'Scan now',
    scan_ok: 'Start scan',
    scanning_text: 'Claude is analyzing the last 30 days of ad decisions, usually 30-60 seconds...',
    msg_generated: 'Generated {count} new insights',
    msg_scan_failed: 'Scan failed, please try again later',
    msg_load_failed: 'Failed to load the insights library',
    msg_action_failed: 'Action failed',
    msg_restore_failed: 'Restore failed',
    confirm_delete: 'Delete this insight? This cannot be undone.',
    delete_title: 'Delete insight',
    delete_confirm_label: 'Delete',
    msg_delete_failed: 'Delete failed',
    rel_just_now: 'just now',
    rel_minutes_ago: '{count} min ago',
    rel_hours_ago: '{count} h ago',
    rel_days_ago: '{count} d ago',
    rel_months_ago: '{count} mo ago',
    rel_years_ago: '{count} yr ago',
  },

  dataQuality: {
    title: 'Data Quality Monitoring',
    subtitle: 'Checks tracking events for loss / drops / duplicates / missing CAPI — a leading indicator of delivery quality (Meta Pixel only for now, other channels coming)',
    refresh: 'Refresh',
    run_now: 'Re-analyze now',
    coverage_title: 'Cross-channel coverage',
    coverage_meta: 'Meta (Facebook Pixel)',
    coverage_meta_status: '✓ Covered — event loss / volume drop / missing Purchase / CAPI heuristics',
    coverage_google: 'Google Ads (Conversion Actions)',
    coverage_google_status: 'Planned — Google Ads API conversion_action metrics',
    coverage_tiktok: 'TikTok Pixel',
    coverage_tiktok_status: 'Planned — TikTok Marketing API event stats',
    coverage_pinterest: 'Pinterest Conversion Tag',
    coverage_microsoft: 'Microsoft UET Tag',
    coverage_planned: 'Planned',
    stat_critical: 'Critical issues',
    stat_active: 'Open issues',
    stat_pixels: 'Pixels monitored',
    tab_active: 'Open',
    tab_resolved: 'Auto-resolved',
    tab_dismissed: 'Dismissed',
    tab_all: 'All',
    col_severity: 'Severity',
    col_problem: 'Problem',
    col_pixel: 'Pixel',
    col_action: 'Suggested action',
    col_first_seen: 'First seen',
    col_actions: 'Actions',
    btn_dismiss: 'Dismiss',
    severity_critical: 'Critical',
    severity_warning: 'Warning',
    severity_info: 'Info',
    empty_active_title: 'Pixel data is healthy',
    empty_other_title: 'Nothing in this category',
    empty_active_desc: 'All pixels reported normally in the last 24 hours. Auto-analyzed daily at 03:00 UTC.',
    empty_other_desc: 'You can also run it manually with Re-analyze now in the top right',
    trend_title: 'Event volume, last 14 days',
    trend_empty: 'No pixel data · click Re-analyze now in the top right to fetch the latest snapshot',
    yesterday: 'yesterday',
    msg_run_done: 'Analysis done · {pixels} pixels · {snapshots} snapshots written · {created} new · {resolved} resolved',
    msg_run_done_errors: ' · {errors} failed',
    msg_load_failed: 'Load failed',
    msg_run_failed: 'Run failed',
    confirm_dismiss: 'Dismiss the "{rule}" alert on "{pixel}"? You won\'t be reminded again.',
    dismiss_title: 'Dismiss alert',
    dismiss_ok: 'Dismiss',
    msg_dismissed: 'Dismissed',
    msg_action_failed: 'Action failed',
    rule_events_stopped: 'Events stopped reporting',
    rule_volume_drop: 'Event volume dropped',
    rule_missing_capi: 'Likely missing CAPI',
    rule_missing_purchase_event: 'Account spending but no Purchase events',
    hint_events_stopped: 'The pixel received no events in the last 24 hours while the account kept spending. The pixel install may be broken / GTM cleared / domain blocked.',
    hint_volume_drop: 'Yesterday\'s event volume is below 70% of the 7-day average. Check that the landing-page script is still present, or whether an A/B test changed the tracking.',
    hint_missing_capi: 'Purchase / ViewContent < 0.5%, usually meaning only browser-side reporting and no server-side (CAPI) hookup. CAPI lets Meta keep conversion data under iOS limits / browser blocking and typically cuts CPA 10–17%.',
    hint_missing_purchase_event: 'The account spent over $100 in 7 days but the pixel fired 0 Purchase events. Usually the pixel isn\'t on the checkout page, or the event name is misspelled.',
    action_enable_capi: 'Set up CAPI / Conversion API',
    action_check_pixel: 'Check pixel install',
    action_check_event_id: 'Check event_id dedup',
    action_check_purchase_event: 'Check Purchase event tracking',
    action_observe: 'Keep observing',
    metric_events_stopped: '0 events in 24h · account spent ${spend}',
    metric_volume_drop: '{event} · yesterday {value} · 7-day avg {baseline} · down {drop}%',
    metric_missing_capi: 'Purchase/ViewContent = {ratio}% (baseline ≥ 0.5%)',
    metric_missing_purchase_event: '7-day spend ${spend} · 0 Purchase events',
    rel_minutes_ago: '{count} min ago',
    rel_hours_ago: '{count} h ago',
    rel_days_ago: '{count} d ago',
  },

  domainMonitoring: {
    title: 'Domain Monitoring',
    subtitle: 'Watches the landing-page domains of live ads to catch hijacked or non-whitelisted links',
    refresh: 'Refresh',
    add_whitelist: 'Add to whitelist',
    scan_now: 'Scan now',
    stat_whitelist: 'Whitelisted domains',
    stat_active: 'Live domains',
    stat_flagged: 'Flagged domains (not whitelisted)',
    tab_flagged: 'Flagged domains',
    tab_whitelist: 'Whitelisted domains',
    col_domain: 'Domain',
    col_ad: 'Ad',
    col_landing: 'Landing page',
    col_status: 'Status',
    col_triage: 'Triage',
    col_label: 'Label',
    col_added: 'Added',
    col_actions: 'Actions',
    btn_whitelist: 'Add to whitelist',
    btn_pause: 'Pause ad',
    btn_remove: 'Remove',
    badge_wildcard: 'Wildcard',
    flagged_ok_title: 'Nothing flagged',
    flagged_ok_desc: 'Every live ad\'s landing-page domain is on your whitelist · {count} domains',
    whitelist_empty_title: 'No whitelisted domains yet',
    whitelist_empty_desc: 'Add your own domains and the system compares them against live ad landing pages, alerting the moment something doesn\'t match',
    dialog_title: 'Add whitelisted domain',
    field_domain: 'Domain',
    field_domain_ph: 'example.com or *.example.com',
    domain_hint_exact: 'exact match',
    domain_hint_wildcard: 'matches all subdomains (incl. apex)',
    field_label: 'Label (optional)',
    field_label_ph: 'e.g. Main site',
    cancel: 'Cancel',
    add: 'Add',
    msg_load_failed: 'Load failed',
    msg_scan_ok: 'Scan complete, no anomalies',
    msg_scan_flagged: 'Scan complete, {count} flagged',
    msg_scan_failed: 'Scan failed',
    msg_need_domain: 'Please enter a domain',
    msg_added: 'Added',
    msg_add_failed: 'Add failed',
    confirm_remove: 'Remove "{domain}" from the whitelist?',
    remove_confirm_label: 'Remove',
    msg_removed: 'Removed',
    msg_delete_failed: 'Delete failed',
    confirm_whitelist: 'Add "{domain}" to the whitelist? All ad alerts for this domain will be cleared.',
    whitelist_ok: 'Add',
    msg_whitelisted: 'Added to whitelist, rescanning',
    msg_already_whitelisted: 'That domain is already whitelisted',
    msg_action_failed: 'Action failed',
    confirm_pause: 'Pause ad "{ad}"? This syncs to {platform} immediately and stops delivery.',
    pause_title: 'Pause ad',
    pause_confirm_label: 'Pause',
    msg_paused: 'Paused',
    msg_pause_failed: 'Pause failed',
    status_active: 'Active',
    status_paused: 'Paused',
  },

  testPlanner: {
    title: 'AI Creative Test Planner',
    subtitle: 'Auto-generates what to test next week from creative lifecycle + tags + health-check results',
    provider_ph: 'AI model',
    provider_default: 'Platform default (Claude)',
    provider_add: '→ Add your own AI model',
    refresh: 'Refresh',
    generate: 'Generate new plan',
    history_title: 'Plan history ({count})',
    empty_title: 'No test plans yet',
    empty_desc: 'Click Generate new plan and let the AI review your current creative data and suggest what to test next week',
    cached_tag: 'Cache hit',
    placeholder_title: 'Pick a plan to view',
    placeholder_desc: 'Open a past plan on the left for detailed recommendations, or generate your first',
    observed_patterns: '🔍 Observed patterns',
    rec_hypothesis: 'Hypothesis',
    rec_variants: 'Suggested directions to test ({count})',
    rec_audience: 'Audience / targeting',
    rec_audience_default: 'Reuse existing targeting',
    rec_success_metric: 'Success metric',
    rec_refs: 'Data basis',
    caveats: '⚠️ Caveats',
    priority_high: 'High priority',
    priority_medium: 'Medium',
    priority_low: 'Watch',
    msg_generated: 'Generated · {count} recommendations · {model} · {seconds}s · est. ${cost}',
    msg_generate_failed: 'Generation failed',
    need_config_title: 'AI model required',
    need_config_ok: 'Go to settings',
    msg_load_failed: 'Load failed',
    msg_load_detail_failed: 'Failed to load details',
    confirm_delete: 'Delete plan "{title}"?',
    delete_title: 'Delete',
    delete_confirm_label: 'Delete',
    msg_deleted: 'Deleted',
    msg_delete_failed: 'Delete failed',
    rel_just_now: 'just now',
    rel_minutes_ago: '{count} min ago',
    rel_hours_ago: '{count} h ago',
    rel_days_ago: '{count} d ago',
  },

  autopilotDashboard: {
    title: 'Product-Driven Autopilot',
    subtitle: 'Scores ads, spots opportunities, and cuts losses or scales winners using your store\'s real operating data (bestsellers, new arrivals, inventory, margin).',
    refresh: 'Refresh',
    rescore: 'Rescore',
    run_policies: 'Run policies',
    kpi_active_policies: 'Active policies',
    kpi_total_policies: '{count} total',
    kpi_pending: 'Pending actions',
    kpi_view_queue: 'View queue →',
    kpi_products: 'Products',
    kpi_sorted_by_score: 'Sorted by opportunity score',
    pending_panel_title: 'Pending actions',
    view_all: 'All →',
    col_type: 'Type',
    col_policy: 'Policy',
    col_target: 'Target',
    col_reason: 'Reason',
    target_product: 'Product: {title}',
    target_ad: 'Ad: {name}',
    ranking_title: 'Product opportunity ranking (top 20)',
    empty_title: 'No product data yet',
    empty_desc: 'Configure an Autopilot policy under Policies, link a commerce connection, and the daily cron syncs and scores it. You can also trigger a manual sync on the policies page.',
    inventory: 'Inventory: {qty}',
    inventory_untracked: 'Not tracked',
    opportunity_score: 'Opportunity score',
    bk_hotness: 'Hot {value}',
    bk_novelty: 'New {value}',
    bk_margin: 'Margin {value}',
    bk_inventory: 'Stock {value}',
    bk_ad_potential: 'Ad {value}',
    published_at: 'Published: {date}',
    synced_at: 'Synced: {date}',
    msg_load_failed: 'Load failed',
    msg_rescored: 'Rescored',
    msg_rescore_failed: 'Rescore failed',
    msg_evaluated: 'Ran {count} policies, created {emitted} actions',
    msg_evaluate_failed: 'Evaluation failed',
  },

  pagesMgmt: {
    title: 'Pages',
    subtitle: 'Facebook Pages / Pinterest Boards and more, used to link a promoting page when creating ads',
    sync: 'Sync Pages',
    refresh: 'Refresh',
    search_ph: 'Search page name',
    platform_ph: 'Channel',
    search: 'Search',
    reset: 'Reset',
    col_page: 'Page',
    uncategorized: 'Uncategorized',
    col_fans: 'Fans',
    col_bm: 'BM',
    col_id: 'ID',
    col_synced: 'Last synced',
    empty_title_filtered: 'No matching pages',
    empty_title: 'No pages synced yet',
    empty_desc: 'After you authorize Facebook and sync, the Pages you manage show up here',
    msg_load_failed: 'Load failed',
    msg_sync_dispatched: 'Dispatched {count} Pages sync job(s)',
    msg_sync_none: 'No connected channel authorization to sync',
    msg_sync_failed: 'Pages sync failed',
  },
  batchCreate: {
    targeting_pack_section: 'Targeting pack',
    f_targeting_pack: 'Use targeting pack',
    targeting_pack_ph: 'Select a saved targeting pack (optional)',
    targeting_pack_help: 'When a pack is selected, ad-set geo/age/gender/interests come from the pack, overriding manual geo targeting.',
    split_section: 'Split count',
    f_split_count: 'Splits per combination',
    split_count_help: 'A/B test the same creative/targeting: each combination is duplicated into N near-identical ad sets (suffixed #1/#2/…). Range 1–10.',
    matrix_title: 'Connect matrix (exclude combinations)',
    matrix_help: "Uncheck combinations you don't want; unchecked cells are skipped.",
    matrix_count: 'Keeping {kept} of {total} combinations',
    bulk_count: '{n} / {total} selected',
    bulk_select_all: 'Select all',
    bulk_clear: 'Clear',
    bulk_invert: 'Invert',
    bulk_only_recommended: 'Recommended only',
    bulk_select_filtered: 'Select filtered',
    title: 'Cross-Multiply Batch Create',
    subtitle: 'Cross-multiply Product × Geo × Audience × Creative × Budget to spin up hundreds of ads at once, with smart pre-selection of high-potential products',
    load_template: 'Load Template',
    recent_jobs: 'Recent Batch Jobs',
    job_progress: 'Done {done}/{total} · Failed {failed}',
    // step labels
    step1: 'Dimensions',
    step2: 'Combine Mode',
    step3: 'Split Rules',
    step4: 'Bid, Budget & Attribution',
    step5: 'Preview',
    prev: 'Back',
    next: 'Next',
    // formula bar
    formula_total: '{n} ads',
    formula_empty: 'Select at least one dimension first',
    formula_over_limit: 'Exceeds the {max}-ad limit',
    formula_warn: 'Large volume — please confirm',
    // dimensions
    dim_product: 'Product',
    dim_geo: 'Geo',
    dim_audience: 'Audience',
    dim_creative: 'Creative',
    dim_bidbudget: 'Bid & Budget',
    only_recommended: 'Recommended only',
    product_hint: 'High-potential products are pre-selected by margin, inventory and opportunity scores (badged "Smart Pick"). Products with an exclude reason are disabled.',
    badge_recommended: 'Smart Pick',
    margin_score: 'Margin {v}',
    inventory_qty: 'Stock {v}',
    no_products: 'No products available',
    no_products_desc: 'Sync products from your commerce store first',
    geo_ph: 'Select target countries/regions',
    audience_ph: 'Select saved audiences',
    no_creatives: 'No creatives available',
    budget_hint: 'Each budget group becomes a separate bid-budget dimension element (daily budget, major units).',
    budget_label: 'Daily ${v}',
    bid_label: 'Bid ${v}',
    add_budget: 'Add budget group',
    // step1 account
    f_account: 'Ad Account',
    account_ph: 'Select ad account',
    create_unsupported: 'Create not supported',
    // step2
    f_mode: 'Combine Mode',
    mode_cross: 'Full cross',
    mode_zip: 'Lockstep',
    mode_cross_help: 'Full cross: every element of each dimension pairs with every other — the full cartesian product.',
    mode_zip_help: 'Lockstep: dimensions pair by index (i-th × i-th), aligned to the shortest dimension.',
    binds_title: 'Free Binding (optional)',
    binds_help: 'Force an element of dimension A to co-occur with an element of dimension B; combos that violate it are dropped. Full-cross mode only.',
    bind_dim_ph: 'Dimension',
    bind_item_ph: 'Element',
    add_bind: 'Add bind',
    bind_incomplete: 'Pick an element from both dimensions',
    bind_same_dim: 'The two bound elements cannot be from the same dimension',
    f_binding_mode: 'Binding mode',
    binding_cross: 'Cross-multiply',
    binding_free: 'Free binding',
    binding_cross_help: 'Full cartesian product of all dimensions (further narrowed by binds/matrix).',
    binding_free_help: 'Hand-pick each combination; no cartesian product.',
    free_title: 'Free-binding combinations',
    free_help: 'Each row picks one element per dimension; leave blank to leave that dimension unconstrained.',
    free_no_dims: 'Pick at least one dimension in the previous step first.',
    free_add: 'Add combination',
    free_any: 'Any',
    naming_section: 'Naming wildcards',
    naming_help: 'Insert wildcards into campaign/adset/ad names; replaced per combination at creation. Leave blank for default naming.',
    naming_tokens: 'Wildcards:',
    naming_insert: 'Insert wildcard',
    naming_ph: 'e.g. {start_time}-{region_code}',
    naming_campaign: 'Campaign name',
    naming_adset: 'Ad set name',
    naming_ad: 'Ad name',
    // step3
    split_help: 'Choose the split level for each dimension: which layer (Campaign / Ad Set / Ad) it fans out at.',
    split_account_rule: 'The ad account is always at the campaign level.',
    split_targeting_warn: 'Placing targeting dimensions (geo/audience) at the Ad level may not behave as expected — Facebook targets at the ad-set level.',
    tree_preview: 'Structure Preview',
    tree_campaigns: '{n} campaigns',
    tree_adsets: '{n} ad sets',
    tree_ads: '{n} ads',
    level_campaign: 'Campaign',
    level_adset: 'Ad Set',
    level_ad: 'Ad',
    // step4
    f_objective: 'Objective',
    f_page: 'Page',
    f_pixel: 'Pixel (optional)',
    page_ph: 'Select page',
    pixel_ph: 'Select pixel',
    ladder_toggle: 'Ladder bidding',
    ladder_min: 'Min bid',
    ladder_max: 'Max bid',
    inject_utm: 'Auto-inject UTM for per-ad profit attribution',
    inject_utm_help: 'When on, each ad carries a unique UTM so you get true per-ad profit attribution — our core edge over XMP.',
    // step5 preview
    blocked_title: '{n} products blocked from creation',
    poas_baseline_val: 'Expected POAS baseline: {poas} (gross margin {margin}%, source: {source})',
    col_campaign: 'Campaign',
    col_adset: 'Ad Set',
    col_ad: 'Ad Name',
    col_budget: 'Budget/Bid',
    save_template: 'Save as Template',
    start_create: 'Start Batch Create ({n})',
    // submit / confirm
    confirm_submit_title: 'Confirm Batch Create',
    confirm_submit: 'About to create {count} ads. Start now?',
    confirm_submit_ok: 'Create',
    job_name_title: 'Name the Job',
    job_name_prompt: 'Give this batch job a name',
    job_name_default: 'Batch Create {date}',
    job_name_required: 'Please enter a job name',
    // execution
    exec_title: 'Running: {name}',
    close_panel: 'Collapse',
    exec_done: 'Done {n}',
    exec_failed: 'Failed {n}',
    exec_skipped: 'Skipped {n}',
    exec_pending: 'Pending {n}',
    retry_failed: 'Retry Failed',
    item_status_pending: 'Pending',
    item_status_running: 'Running',
    item_status_done: 'Done',
    item_status_failed: 'Failed',
    item_status_skipped: 'Skipped',
    job_status_pending: 'Pending',
    job_status_running: 'Running',
    job_status_done: 'Done',
    job_status_partial: 'Partial',
    job_status_failed: 'Failed',
    job_status_cancelled: 'Cancelled',
    // templates
    tpl_save_title: 'Save Template',
    tpl_save_prompt: 'Name this batch config template',
    tpl_name_required: 'Please enter a template name',
    // messages
    msg_load_failed: 'Load failed',
    msg_preview_failed: 'Preview failed',
    msg_submitted: 'Batch job submitted',
    msg_submit_failed: 'Submit failed',
    msg_retry_started: 'Failed items re-submitted',
    msg_retry_failed: 'Retry failed',
    msg_tpl_saved: 'Template saved',
    msg_tpl_loaded: 'Loaded template "{name}"',
    err_no_account: 'Select an ad account first',
    err_no_dim: 'Select elements for at least one dimension',
  },
  oneClick: {
    title: 'One-Click Launch', subtitle: 'Paste a product URL + set budget/targets → AI-generated ads → launch',
    step_input: 'Product & targets', step_preview: 'Preview plan', step_run: 'Submit & track',
    ad_account: 'Ad account', objective: 'Objective', product: 'Product', by_url: 'Paste URL', by_select: 'Pick synced product',
    url_placeholder: 'Paste the storefront product URL (Shopify / Shoplazza / …)', select_product: 'Select product',
    url_hint: 'One-click launch uses products already synced from your store; it does not scrape external URLs.',
    daily_budget: 'Daily budget', target_cpa: 'Target CPA', target_roas: 'Target ROAS', optional: 'Optional',
    page: 'Facebook Page', pixel: 'Pixel (optional)', keywords: 'Keywords / selling points', keywords_placeholder: 'Separate with commas or new lines',
    reference_images: 'Reference images', upload_image: 'Upload image', reference_hint: 'Each reference image becomes its own ad; product image is used if none.',
    inject_utm: 'Inject UTM tracking (per-ad / per-product attribution)', generate: 'Generate plan',
    pick_account_first: 'Pick an ad account first', image_uploaded: 'Image uploaded',
    view_product: 'View product', ai_copy: 'AI ad copy', headline: 'Headline', primary_text: 'Primary text', description: 'Description', cta: 'Call to action',
    safety_flags: 'Copy review: flagged "{words}" — please review.',
    plan: 'Ad plan', count_campaigns: '{n} campaign(s)', count_adsets: '{n} ad set(s)', count_ads: '{n} ad(s)',
    budget_summary: 'Daily {v}', cpa_summary: 'Target CPA {v}', roas_summary: 'Target ROAS {v}', per_day: 'day',
    back: 'Back', submit: 'Confirm & launch', submitted: 'Submitted, creating…', launch_another: 'Launch another',
    run_done: 'Done {n}', run_failed: 'Failed {n}', run_pending: 'In progress {n}', no_accounts: 'No ad accounts available for creation',
    job_status_pending: 'Queued', job_status_running: 'Creating', job_status_done: 'Done',
    job_status_partial: 'Partial', job_status_failed: 'Failed', job_status_cancelled: 'Cancelled',
  },
  ruleTemplates: {
    library_btn: 'Template library',
    drawer_title: 'Rule template library',
    drawer_intro: 'Create a rule in one click from a template below. It opens in the editor in Simulate mode — review it, then enable.',
    save_as: 'Save as template',
    use: 'Use this template',
    delete: 'Delete',
    builtin_tag: 'Built-in',
    cat_stop_loss: 'Stop loss',
    cat_repricing: 'Repricing',
    cat_budget: 'Budget',
    cat_notify: 'Notifications',
    cat_custom: 'Custom',
    empty_title: 'No templates',
    empty_desc: 'Built-in templates failed to load or were cleared',
    save_dialog_title: 'Save as template',
    form_name: 'Template name',
    form_name_placeholder: 'Name this template',
    form_desc: 'Description',
    form_desc_placeholder: 'Briefly describe what this template is for (optional)',
    form_category: 'Category',
    cancel: 'Cancel',
    save_btn: 'Save template',
    confirm_delete_title: 'Delete template',
    confirm_delete: 'Delete template "{name}"?',
    confirm_delete_label: 'Delete',
    msg_load_failed: 'Failed to load templates',
    msg_saved: 'Template saved',
    msg_save_failed: 'Failed to save template',
    msg_deleted: 'Template deleted',
    msg_delete_failed: 'Failed to delete template',
    msg_name_required: 'Please enter a template name',
  },
  aiCopy: {
    entryButton: 'AI Copy',
    title: 'AI Ad Copy Generator',
    productTitle: 'Product name',
    productTitlePlaceholder: 'e.g. Portable Bluetooth insulated mug',
    sellingPoints: 'Key selling points',
    sellingPointsPlaceholder: 'One per line, e.g.:\n12-hour heat retention\nOne-touch lid\nFood-grade stainless steel',
    audience: 'Target audience',
    audiencePlaceholder: 'e.g. commuting professionals aged 25-40',
    tone: 'Tone',
    tonePlaceholder: 'Default',
    tone_professional: 'Professional',
    tone_friendly: 'Friendly',
    tone_urgent: 'Urgent',
    tone_playful: 'Playful',
    tone_luxury: 'Luxury',
    platform: 'Platform',
    platform_meta: 'Meta (Facebook / Instagram)',
    platform_tiktok: 'TikTok',
    platform_google: 'Google',
    targetLang: 'Output language',
    'lang_zh-CN': 'Chinese',
    'lang_en-US': 'English',
    generate: 'Generate',
    close: 'Close',
    copy: 'Copy',
    saveTemplate: 'Save as template',
    tabPrimary: 'Primary text',
    tabHeadlines: 'Headlines',
    tabDescriptions: 'Descriptions',
    tabCta: 'CTA',
    tabDirections: 'Test directions',
    safetyWarning: 'Possible ad-policy violations detected — please review: {words}',
    metaLine: 'Model {model} · est. cost ${cost}',
    msgNeedTitle: 'Please enter a product name first',
    msgGenerated: 'Copy generated',
    msgGenerateFailed: 'Generation failed',
    msgCopied: 'Copied to clipboard',
    msgCopyFailed: 'Copy failed',
  },
  notifyChannels: {
    title: 'Notification Channels',
    hint: 'Push workspace notifications to Feishu / DingTalk / WeCom group bots or a custom webhook — an extra alerting channel beyond in-app and email. Secrets are encrypted and never returned.',
    refresh: 'Refresh',
    add: 'Add channel',
    edit: 'Edit',
    delete: 'Delete',
    test: 'Send test',
    save: 'Save',
    cancel: 'Cancel',
    error: 'Error',
    loadFailed: 'Failed to load',
    saveFailed: 'Failed to save',
    deleteFailed: 'Failed to delete',
    created: 'Added',
    updated: 'Updated',
    deleted: 'Deleted',
    testOk: 'Test message sent',
    testFailed: 'Test failed: {error}',
    confirmDelete: 'Delete channel "{name}"? It will stop receiving notifications.',
    type: {
      feishu: 'Feishu',
      dingtalk: 'DingTalk',
      wecom: 'WeCom',
      webhook: 'Custom Webhook',
    },
    level: {
      info: 'All',
      warning: 'Warning and above',
      error: 'Errors only',
    },
    event: {
      auth_expired: 'Auth expired',
      sync_failed: 'Sync failed',
      domain_alert: 'Domain alert',
      policy_event: 'Policy event',
      system: 'System',
      info: 'Info',
    },
    col: {
      name: 'Name',
      type: 'Type',
      minLevel: 'Level',
      active: 'Active',
      actions: 'Actions',
    },
    field: {
      type: 'Channel type',
      name: 'Name',
      namePlaceholder: 'e.g. Ops monitoring group',
      url: 'Webhook URL',
      urlPlaceholder: 'https://...',
      signEnabled: 'Enable signature verification',
      secret: 'Signing secret',
      secretPlaceholder: "The signing secret from the bot's security settings",
      secretKeepHint: '(leave blank to keep the current secret)',
      eventTypes: 'Events to receive',
      eventTypesPlaceholder: 'None selected = receive all events',
      eventTypesHint: 'Leave empty to receive every notification type.',
      minLevel: 'Minimum level',
    },
    dialog: {
      addTitle: 'Add notification channel',
      editTitle: 'Edit notification channel',
    },
    rule: {
      name: 'Name is required',
      url: 'Webhook URL is required',
    },
    empty: {
      title: 'No notification channels yet',
      desc: 'Add a Feishu / DingTalk / WeCom group bot or a custom webhook to mirror workspace alerts there.',
      action: 'Add your first',
    },
  },
  bulkEdit: {
    assign_label: 'Bulk assign',
    assign_apply: 'Apply',
    assign_status_ph: 'Status',
    assign_budget_ph: 'Daily budget',
    assign_bid_ph: 'Bid',
    assign_factor_ph: 'Factor',
    apply: 'Apply',
    cancel: 'Cancel',
    error_unknown: 'Unknown error',
    result_ok: 'Success',
    result_fail: 'Failed',
    col_name: 'Name',
    col_status: 'Status',
    col_budget: 'Daily budget (USD)',
    col_bid: 'Bid (USD)',
    col_result: 'Result',
    status_on: 'On',
    status_off: 'Off',
    tag_unsupported: 'Unsupported',
    table_entry: 'Table edit',
    table_title_campaigns: 'Bulk edit campaigns (table)',
    table_title_adsets: 'Bulk edit ad sets (table)',
    table_title_ads: 'Bulk edit ads (table)',
    table_meta: '{count} rows selected',
    table_meta_skipped: '{count} on channels that do not support editing (disabled)',
    table_no_writable: 'No editable rows (selected rows are all on unsupported channels)',
    table_no_changes: 'No changes to apply',
    table_confirm_title: 'Confirm bulk edit',
    table_confirm_message: 'Apply changes to {count} rows and sync to channels?',
    table_apply: 'Apply to {count} rows',
    table_success: 'Updated {ok} rows',
    table_partial: '{ok} succeeded, {fail} failed',

  },
  byFilterBulk: {
    entry: 'Bulk-act on filter results',
    title: 'Bulk action by filter',
    header: 'Bulk action on all {total} {level} matching the current filter',
    level_campaign: 'campaigns',
    level_adset: 'ad sets',
    level_ad: 'ads',
    action_label: 'Action type',
    action_status: 'Change status',
    action_budget_set: 'Set daily budget',
    action_budget_factor: 'Daily budget × factor',
    action_bid_factor: 'Bid × factor',
    status_label: 'Target status',
    status_active: 'Enable',
    status_paused: 'Pause',
    status_archived: 'Archive',
    budget_label: 'Daily budget',
    budget_ph: 'Uniform daily budget',
    currency_suffix: 'USD',
    factor_label: 'Factor',
    factor_ph: 'e.g. 0.8 / 1.2',
    factor_hint: 'Multiply the current value by the factor',
    writable_note: 'Applies only to writable channels (facebook) and entities that actually change; unchanged or non-writable entities are skipped automatically.',
    invalid_value: 'Enter a valid value (must be greater than 0)',
    summary_status: 'status → {status}',
    summary_budget_set: 'daily budget → {value}',
    summary_budget_factor: 'daily budget ×{factor}',
    summary_bid_factor: 'bid ×{factor}',
    confirm_title: 'Confirm bulk action',
    confirm_message: 'Apply "{action}" to all {total} {level} matching the current filter and sync to channels?',
    confirm_ok: 'Execute',
    submit_btn: 'Run on all {total}',
    submit_failed: 'Failed to submit job',
    job_name: 'Bulk by filter {level} · {time}',
    cancel: 'Cancel',
    exec_counts: 'Done {done}/{total} · failed {failed} · skipped {skipped}',
    polling: 'Running, auto-refreshing…',
    field_status: 'Status',
    field_daily_budget: 'Daily budget',
    field_bid: 'Bid',
    col_label: 'Object',
    col_op: 'Operation',
    col_status: 'Status',
    col_error: 'Error',
    item_status_pending: 'Pending',
    item_status_updating: 'Updating',
    item_status_done: 'Done',
    item_status_failed: 'Failed',
    item_status_skipped: 'Skipped',
    job_status_pending: 'Pending',
    job_status_running: 'Running',
    job_status_done: 'Done',
    job_status_failed: 'Failed',
    job_status_cancelled: 'Cancelled',
    job_status_partial: 'Partial',
    retry_btn: 'Retry failed items',
    retry_failed: 'Retry failed',
    close: 'Close',
  },
  creativeLibrary: {
    activeTags: 'Selected tags',
    select: 'Select',
    exitSelect: 'Exit select',
    selectedCount: '{count} selected',
    selectFirst: 'Select creatives first',
    clearSelection: 'Clear',
    batchTag: 'Batch tag',
    batchTagTitle: 'Batch tag ({count} creatives)',
    batchTagged: 'Tagged {count} creatives',
    batchUntagged: 'Untagged {count} creatives',
    tagAction: 'Action',
    tagAdd: 'Add',
    tagRemove: 'Remove',
    tagDimension: 'Dimension',
    tagValue: 'Tag value',
    tagValuePlaceholder: 'e.g. pain-point, UGC, comparison',
    tagValueRequired: 'Tag value is required',
    apply: 'Apply',
    clearTagFilter: 'Clear tag filter',
    tagType_angle: 'Angle',
    tagType_selling_point: 'Selling point',
    tagType_format: 'Format',
    tagType_hook: 'Hook',
    tagType_custom: 'Custom',
    realProfit: 'Real profit',
    startDate: 'Start date',
    endDate: 'End date',
    sortNone: 'No sort',
    sortPoas: 'By real POAS',
    sortGrossProfit: 'By gross profit',
    spend: 'Spend',
    grossProfit: 'Gross profit',
    poas: 'Real POAS',
    orders: 'Orders',
    noProfitData: 'No profit data',
    profitLoadFailed: 'Failed to load profit data',
    profitCaption: 'Creative-level real profit (after COGS/refunds) — XMP only shows ROAS.',
    mixedCurrency: 'Data spans multiple currencies; shown in {currency} for reference only',
    useCreative: 'Use in new ad',
    // Folders
    folderAll: 'All',
    folderUnfiled: 'Unfiled',
    folderNew: 'New folder',
    folderNamePlaceholder: 'Enter folder name',
    folderNamePrompt: 'Folder name',
    folderParent: 'Parent folder (optional)',
    folderParentNone: 'Top level',
    folderCreated: 'Folder created',
    folderCreateFailed: 'Failed to create folder',
    folderRename: 'Rename',
    folderRenamed: 'Folder renamed',
    folderRenameFailed: 'Failed to rename folder',
    folderDelete: 'Delete folder',
    folderDeleteConfirm: 'Delete folder "{name}"? Its creatives become unfiled (not deleted) and subfolders move up.',
    folderDeleted: 'Folder deleted',
    folderDeleteFailed: 'Failed to delete folder',
    folderNameRequired: 'Folder name is required',
    folderLoadFailed: 'Failed to load folders',
    // Batch move
    batchMove: 'Move to folder',
    moveTitle: 'Move {count} creatives',
    moveTarget: 'Target folder',
    moveToUnfiled: 'Remove from folder (unfiled)',
    moved: 'Moved {count} creatives',
    moveFailed: 'Move failed',
    // Batch upload
    uploadTargetFolder: 'Target folder',
    uploadFolderNone: 'Unfiled',
    uploadQueue: 'Upload queue',
    uploadStatus_pending: 'Pending',
    uploadStatus_uploading: 'Uploading',
    uploadStatus_done: 'Done',
    uploadStatus_failed: 'Failed',
    uploadSummary: 'Success {ok} / Failed {fail}',
    uploadPickFiles: 'Multiple files allowed; they upload one by one.',
  },
  creativeEditor: {
    entryButton: 'Edit image',
    editThisImage: 'Edit this image',
    title: 'Creative editor',
    // Source / loading
    pickImage: 'Pick image',
    pickImagePlaceholder: 'Pick a local image to start editing',
    sourceLoadFailed: 'Failed to load image — please pick a local image instead',
    taintedWarning: 'This creative is served from an external CDN and cannot be exported. Please pick a local image instead.',
    noImage: 'Please pick or load an image first',
    loadingImage: 'Loading image…',
    // Aspect ratio
    ratioLabel: 'Ratio',
    ratioOriginal: 'Original',
    ratioSquare: '1:1 Square',
    ratioPortrait: '4:5 Portrait',
    ratioStory: '9:16 Story/Reel',
    ratioLandscape: '1.91:1 Landscape',
    // Adjustments
    adjustLabel: 'Adjust',
    brightness: 'Brightness',
    contrast: 'Contrast',
    backgroundColor: 'Background',
    backgroundColorHint: 'Used for letterboxed areas when changing ratio',
    // Text overlay
    textLabel: 'Text',
    addText: 'Add text',
    textContent: 'Text',
    textContentPlaceholder: 'e.g. 50% OFF today',
    fontSize: 'Font size',
    fontColor: 'Color',
    position: 'Position',
    posTop: 'Top',
    posMiddle: 'Middle',
    posBottom: 'Bottom',
    posLeft: 'Left',
    posCenter: 'Center',
    posRight: 'Right',
    removeText: 'Remove',
    dragHint: 'Drag text on the canvas to reposition',
    // Save
    saveTargetAccount: 'Save to ad account',
    saveTargetAccountPlaceholder: 'Select ad account',
    saveTargetFolder: 'Target folder',
    saveFolderNone: 'Unfiled',
    fileName: 'File name',
    fileNamePlaceholder: 'Enter a name for the new creative',
    save: 'Save as new creative',
    saving: 'Saving…',
    saved: 'Saved as new creative',
    saveFailed: 'Save failed',
    exportFailed: 'Failed to export canvas',
    pickAccountFirst: 'Please select an ad account first',
    nameRequired: 'Please enter a file name',
    reset: 'Reset',
    cancel: 'Cancel',
  },
} as const;
